import React, { createContext, useContext, useMemo, useState } from 'react'

export type Lang = 'it' | 'en'
type Dict = Record<string, string>

const IT_DICT: Dict = {
  'common.loading': 'Caricamento...',
  'nav.menu': 'Menu',
  'nav.settings': 'Impostazioni',
  'nav.home': 'Home',
  'nav.tenants': 'Tenants',
  'nav.endpoints': 'Endpoints',
  'nav.policies': 'Policies',
  'nav.schedules': 'Schedules',
  'nav.repos': 'Repositories',
  'nav.jobs': 'Jobs',
  'nav.rbac': 'RBAC',
  'nav.health': 'Health',
  'nav.restore': 'Ripristino',
  'settings.version': 'Versione software',
  'settings.monitoring.title': 'Monitoraggio e Alerting',
  'settings.monitoring.subtitle': 'Configura i provider Prometheus Pushgateway e stack ELK per metriche e log.',
  'settings.monitoring.updated_at': 'Aggiornato',
  'settings.monitoring.enabled': 'Abilita monitoraggio globale',
  'settings.monitoring.enabled_hint': 'Quando disabilitato nessun dato viene inviato ma le impostazioni restano salvate.',
  'settings.monitoring.prometheus': 'Prometheus',
  'settings.monitoring.prometheus.pushgateway': 'URL Pushgateway',
  'settings.monitoring.prometheus.remote_write': 'URL remote write',
  'settings.monitoring.prometheus.job': 'Job name',
  'settings.monitoring.prometheus.user': 'Utente basic auth',
  'settings.monitoring.prometheus.password': 'Password basic auth',
  'settings.monitoring.prometheus.password_set': 'Password salvata: lascia vuoto per mantenerla.',
  'settings.monitoring.prometheus.password_clear': 'Azzera password salvata',
  'settings.monitoring.elk': 'Elastic / ELK',
  'settings.monitoring.elk.endpoint': 'Endpoint',
  'settings.monitoring.elk.index': 'Indice',
  'settings.monitoring.elk.username': 'Username / API key ID',
  'settings.monitoring.elk.password': 'Password / API key',
  'settings.monitoring.elk.password_set': 'Credenziale salvata: lascia vuoto per mantenerla.',
  'settings.monitoring.elk.password_clear': 'Azzera credenziale salvata',
  'settings.monitoring.save': 'Salva configurazione monitoraggio',
  'header.hi': 'Ciao,',
  'landing.title': 'Benvenuto nel pannello di backup SaaS',
  'landing.subtitle': 'Gestione centralizzata di backup, restore e monitoraggio',
  'landing.body': 'Accedi per proteggere i tenant, controllare i job e reagire rapidamente agli avvisi.',
  'landing.feature.monitor': 'Monitoraggio in tempo reale di job, code e servizi critici.',
  'landing.feature.restore': 'Procedure guidate di ripristino per ridurre i tempi di fermo.',
  'landing.feature.audit': 'Tracciamento completo delle azioni per audit e compliance.',
  'landing.notice': 'Accesso riservato agli amministratori autorizzati.',
  'buttons.login': 'Login',
  'buttons.logout': 'Logout',
  'buttons.run_backup': 'Esegui Backup',
  'buttons.export_csv': 'Export CSV',
  'buttons.create': 'Crea',
  'buttons.add': 'Aggiungi',
  'buttons.delete': 'Elimina',
  'buttons.enable': 'Abilita',
  'buttons.disable': 'Disabilita',
  'buttons.edit': 'Modifica',
  'buttons.save': 'Salva',
  'buttons.cancel': 'Annulla',
  'titles.tenants': 'Tenants',
  'titles.endpoints': 'Endpoints',
  'titles.targets_for': 'Targets per endpoint {id}',
  'titles.policies': 'Policies',
  'titles.schedules': 'Schedules',
  'titles.repos': 'Repositories',
  'titles.jobs': 'Jobs',
  'titles.rbac': 'Gestione RBAC',
  'titles.health': 'Stato Servizi',
  'help.tenants': 'I tenants rappresentano le organizzazioni/ambiti logici. Usa il selettore in alto per scegliere il tenant corrente. Qui gli amministratori possono vedere l\'elenco dei tenant disponibili.',
  'help.endpoints': 'Gli endpoints sono i server/istanze su cui gira l\'agente di backup. Registra un nuovo endpoint, poi aggiungi i target relativi a ciA2 che vuoi proteggere. L\'agente deve risultare "enrolled".',
  'endpoints.errors.name_required': 'Nome obbligatorio.',
  'endpoints.errors.create_failed': 'Creazione endpoint fallita.',
  'endpoints.errors.no_permission': 'Non hai i permessi per creare endpoint.',
  'endpoints.actions.install': 'Installer agente',
  'endpoints.actions.delete_confirm': 'Eliminare endpoint #{id}? Verranno rimossi targets/agents/schedules legati.',
  'endpoints.table.preflight': 'Preflight',
  'endpoints.installer.title': 'Installer per {name}',
  'endpoints.installer.hint': 'Genera un token temporaneo e copia lo script o il comando Docker da eseguire sulla macchina dell\'endpoint.',
  'endpoints.installer.minutes': 'Validita\' (minuti)',
  'endpoints.installer.generate': 'Rigenera',
  'endpoints.installer.error': 'Impossibile generare l\'installer. Riprovare.',
  'endpoints.installer.script': 'Script Linux (systemd)',
  'endpoints.installer.docker': 'Comando Docker',
  'help.targets': 'I target definiscono cosa salvare (es. Nextcloud o una directory). Per ogni endpoint, aggiungi uno o piA1 target. Le policy/schedule determinano quando verranno eseguiti i backup.',
  'help.policies': 'Le policy definiscono come (retention) e quando (schedule) eseguire i backup, oltre a opzioni di notifica/verifica. Collega la policy a uno o piA1 endpoint tramite le Schedules.',
  'stateful.heading': 'Regole stateful',
  'stateful.help': 'Configura regole per conservare snapshot legati a mailbox o tag specifici. Puoi usare pi? pattern separati da virgola o punto e virgola.',
  'stateful.add': 'Aggiungi regola',
  'stateful.description': 'Descrizione (opzionale)',
  'stateful.mailbox': 'Mailbox o pattern (es. Archivio*)',
  'stateful.tag': 'Tag Restic (opzionale)',
  'stateful.keep_last': 'Keep last (numero snapshot)',
  'stateful.keep_within': 'Keep within (es. 90d)',
  'stateful.none': 'Nessuna regola',
  'stateful.remove': 'Rimuovi',
  'stateful.hint': 'Per pi? valori usa virgola o punto e virgola. Se lasci vuoto Keep last, il sistema blocca le snapshot tramite keep-tag automatico.',
  'policy.strategy': 'Strategia backup',
  'policy.strategy.full': 'Completo',
  'policy.strategy.differential': 'Differenziale',
  'policy.strategy.incremental': 'Incrementale',
  'policy.strategy.log': 'Log transazionale',
  'policy.max_non_full': 'Max backup non full',
  'policy.full_interval': 'Intervallo full',
  'policy.kpi.title': 'Automazioni KPI',
  'policy.kpi.empty': 'Nessuna regola KPI configurata.',
  'policy.kpi.fields.type': 'Tipo',
  'policy.kpi.fields.label': 'Etichetta',
  'policy.kpi.fields.label_ph': 'Descrizione opzionale',
  'policy.kpi.fields.severity': 'SeveritÃÂ ',
  'policy.kpi.fields.cooldown': 'Cooldown (min)',
  'policy.kpi.type.size': 'Variazione dimensione',
  'policy.kpi.type.failure': 'Serie di errori',
  'policy.kpi.fields.threshold_percent': 'Soglia %',
  'policy.kpi.fields.window': 'Campioni consecutivi',
  'policy.kpi.fields.direction': 'Direzione',
  'policy.kpi.direction.increase': 'Aumento',
  'policy.kpi.direction.decrease': 'Diminuzione',
  'policy.kpi.direction.both': 'Entrambe',
  'policy.kpi.fields.threshold_fail': 'Errori consecutivi',
  'policy.kpi.fields.resume': 'Auto riprendi (min)',
  'policy.kpi.actions.force_full': 'Forza backup full',
  'policy.kpi.actions.pause': 'Metti in pausa la schedule',
  'policy.kpi.actions.extend_keep': 'Estendi keep-last',
  'policy.kpi.fields.keep_min': 'Keep minimo',
  'policy.kpi.fields.keep_inc': 'Incremento',
  'policy.kpi.fields.keep_duration': 'Durata (ore)',
  'policy.kpi.actions.notify': 'Invia notifica',
  'policy.kpi.severity.info': 'Info',
  'policy.kpi.severity.warning': 'Warning',
  'policy.kpi.severity.critical': 'Critico',
  'policy.kpi.add_size': 'Aggiungi regola dimensione',
  'policy.kpi.add_failure': 'Aggiungi regola errori',
  'policy.kpi.column': 'Regole KPI',
  'policy.freeze.title': 'Finestre di freeze',
  'policy.freeze.empty': 'Nessuna finestra configurata.',
  'policy.freeze.fields.days': 'Giorni (es. lun-ven)',
  'policy.freeze.fields.start': 'Inizio',
  'policy.freeze.fields.end': 'Fine',
  'policy.freeze.add': 'Aggiungi finestra',
  'policy.freeze.hint': 'Durante queste finestre le schedule vengono sospese automaticamente.',
  'policy.freeze.column': 'Finestre freeze',
  'help.schedules': 'Le schedules collegano un endpoint a una policy e ne abilitano l\'esecuzione automatica. Puoi abilitarle/disabilitarle e rimuoverle.',
  'schedule.fields.policy': 'Policy',
  'schedule.fields.repository': 'Repository',
  'schedule.fields.target': 'Target',
  'schedule.table.policy': 'Policy',
  'schedule.table.repository': 'Repository',
  'schedule.table.target': 'Target',
  'schedule.table.last_success': 'Ultimo backup riuscito',
  'schedule.table.last_check': 'Ultima verifica',
  'schedule.table.last_restore': 'Ultimo ripristino di prova',
  'schedule.table.status': 'Stato',
  'schedule.table.next_run': 'Prossima esecuzione',
  'schedule.status.paused': 'Pianificazione in pausa',
  'schedule.status.resume': 'Riprende il {value}',
  'schedule.status.kpi_triggered': 'Regola KPI attiva',
  'schedule.status.preflight_required': 'Preflight richiesto',
  'schedule.status.preflight_prefix': 'Preflight',
  'schedule.status.ok': 'OK',
  'schedule.status.next_force_full': 'Il prossimo run eseguirà un full',
  'schedule.actions.force_full': 'Forza prossimo full',
  'preflight.actions.run': 'Esegui preflight',
  'preflight.status.never': 'Mai eseguito',
  'preflight.feedback.queued': 'Preflight accodato',
  'preflight.errors.failed': 'Esecuzione preflight fallita',
  'schedule.errors.targets_load_failed': 'Errore caricando i target per l\'endpoint.',
  'schedule.errors.missing_fields': 'Seleziona endpoint, policy, repository e target.',
  'schedule.errors.create_failed': 'Creazione schedule fallita.',
  'schedule.feedback.created': 'Schedule creata.',
  'schedule.feedback.no_permission': 'Non hai i permessi per creare schedule.',
  'schedule.feedback.confirm_delete': 'Eliminare questa schedule?',
  'schedule.feedback.force_full': 'Il prossimo backup verrà eseguito come full.',
  'schedule.errors.force_full_failed': 'Impossibile forzare il prossimo full.',
  'help.repos': 'I repository sono le destinazioni di backup (es. S3, Local, B2, Azure). Crea uno o piA1 repository per tenant: le policy e i job li useranno in base alla configurazione.',
  'repo.type.s3': 'Amazon S3 / compatibile',
  'repo.type.s3.desc': 'Configura un repository Restic su Amazon S3 o storage compatibile (es. MinIO, Wasabi).',
  'repo.type.local': 'Storage locale',
  'repo.type.local.desc': 'Usa un percorso locale montato sull\'agente (es. NFS). Assicurati dei permessi di scrittura.',
  'repo.type.b2': 'Backblaze B2',
  'repo.type.b2.desc': 'Configura un repository su Backblaze B2.',
  'repo.type.azure': 'Azure Blob Storage',
  'repo.type.azure.desc': 'Configura un repository su Azure Blob Storage.',
  'repo.type.sftp': 'SFTP (SSH)',
  'repo.type.sftp.desc': 'Use an SSH SFTP endpoint as the Restic repository.',
  'repo.type.rest': 'REST Server',
  'repo.type.rest.desc': 'Collegati a un server Restic REST (o endpoint HTTP compatibile).',
  'repo.type.swift': 'OpenStack Swift',
  'repo.type.swift.desc': 'Usa un account Swift/OpenStack come repository Restic.',
  'repo.type.gs': 'Google Cloud Storage',
  'repo.type.gs.desc': 'Configura un repository Restic su Google Cloud Storage.',
  'repo.type.rclone': 'Remote rclone',
  'repo.type.rclone.desc': 'Punta a un backend supportato da rclone tramite un remoto configurato.',
  'repo.fields.bucket': 'Bucket',
  'repo.fields.region': 'Regione',
  'repo.fields.endpoint': 'Endpoint',
  'repo.fields.access_key': 'Access key',
  'repo.fields.secret_key': 'Secret key',
  'repo.fields.password': 'Password',
  'repo.fields.prefix': 'Prefisso',
  'repo.fields.storage_class': 'Storage class',
  'repo.fields.kms_key_id': 'KMS key ID',
  'repo.fields.path': 'Percorso',
  'repo.fields.snapshot_retention': 'Retention snapshot',
  'repo.fields.key_id': 'Key ID',
  'repo.fields.application_key': 'Application key',
  'repo.fields.account_name': 'Account name',
  'repo.fields.account_key': 'Account key',
  'repo.fields.container': 'Container',
  'repo.fields.sas_token': 'SAS token',
  'repo.fields.auth_url': 'Auth URL',
  'repo.fields.username': 'Username',
  'repo.fields.auth_password': 'Swift account password',
  'repo.fields.project': 'Project/Tenant',
  'repo.fields.tenant_id': 'Tenant ID',
  'repo.fields.domain': 'Domain',
  'repo.fields.credentials_json': 'Credentials JSON',
  'repo.fields.project_id': 'Project ID',
  'repo.fields.remote': 'Rclone remote',
  'repo.fields.config_text': 'Rclone config',
  'repo.fields.host': 'Host',
  'repo.fields.port': 'Porta',
  'repo.fields.user': 'Utente',
  'repo.fields.remote_path': 'Percorso remoto',
  'repo.fields.private_key': 'Chiave privata SSH',
  'repo.fields.known_hosts': 'Known hosts',
  'repo.fields.ssh_options': 'Opzioni SSH aggiuntive',
  'repo.fields.url': 'URL server',
  'repo.fields.http_password': 'Password HTTP',
  'repo.fields.auth_token': 'Token di autenticazione',
  'repo.fields.ca_cert': 'Certificato CA',
  'repo.placeholder.bucket': 'es. backup-bucket',
  'repo.placeholder.region': 'es. eu-central-1',
  'repo.placeholder.endpoint': 'es. https://s3.amazonaws.com',
  'repo.placeholder.access_key': 'access key',
  'repo.placeholder.secret_key': 'secret key',
  'repo.placeholder.password': 'password restic',
  'repo.placeholder.prefix': 'prefisso opzionale',
  'repo.placeholder.storage_class': 'es. STANDARD',
  'repo.placeholder.kms_key_id': 'ARN KMS opzionale',
  'repo.placeholder.path': 'es. /mnt/backups',
  'repo.placeholder.snapshot_retention': 'es. 30g',
  'repo.placeholder.key_id': 'B2 key ID',
  'repo.placeholder.application_key': 'B2 application key',
  'repo.placeholder.b2_endpoint': 'Endpoint personalizzato (opzionale)',
  'repo.placeholder.account_name': 'es. backupstorage',
  'repo.placeholder.account_key': 'Chiave account',
  'repo.placeholder.container': 'Nome container',
  'repo.placeholder.azure_endpoint': 'Endpoint personalizzato (opzionale)',
  'repo.placeholder.sas_token': 'SAS token (opzionale)',
  'repo.placeholder.auth_url': 'https://identity.example.com/v3',
  'repo.placeholder.auth_password': 'password Swift/OpenStack',
  'repo.placeholder.project': 'es. backup-project',
  'repo.placeholder.tenant_id': 'Opzionale',
  'repo.placeholder.domain': 'Default',
  'repo.placeholder.credentials_json': '{ ... }',
  'repo.placeholder.project_id': 'es. progetto-gcp',
  'repo.placeholder.remote': 'gdrive',
  'repo.placeholder.config_text': '[remote]\nclient_id=...\nclient_secret=...',
  'repo.placeholder.host': 'backup.example.com',
  'repo.placeholder.port': '22',
  'repo.placeholder.user': 'backup',
  'repo.placeholder.remote_path': '/srv/restic',
  'repo.placeholder.private_key': '-----BEGIN OPENSSH PRIVATE KEY-----',
  'repo.placeholder.known_hosts': 'ssh-ed25519 AAAA... host',
  'repo.placeholder.ssh_options': '-o StrictHostKeyChecking=yes',
  'repo.placeholder.url': 'https://rest.example.com/backup',
  'repo.placeholder.username': 'restic',
  'repo.placeholder.http_password': 'password HTTP',
  'repo.placeholder.auth_token': 'token bearer',
  'repo.placeholder.ca_cert': '-----BEGIN CERTIFICATE-----',
  'repo.helper.private_key': 'Opzionale: incolla la chiave privata dedicata all\'utente SSH.',
  'repo.helper.known_hosts': 'Facoltativo: elenco known_hosts per il controllo dell\'host remoto.',
  'repo.helper.ssh_options': 'Opzioni extra per il comando ssh (una per riga).',
  'repo.helper.ca_cert': 'Certificato CA aggiuntivo (PEM) se il server REST usa TLS personalizzato.',
  'repo.helper.auth_token': 'Se valorizzato, verra inviato come Bearer token nelle richieste REST.',
  'repo.helper.credentials_json': 'JSON del service account (Google Cloud).',
  'repo.helper.config_text': 'Contenuto di un file rclone.conf (se vuoto usa quello di sistema).',
  'repo.helper.secret_keep': 'Lascia vuoto per mantenere il valore attuale.',
  'repo.summary.secrets': 'Credenziali archiviate in modo sicuro',
  'repo.table.status': 'Stato',
  'repo.table.preflight': 'Preflight',
  'repo.table.last_error': 'Ultimo errore',
  'repo.status.quarantined': 'In quarantena',
  'repo.status.healthy': 'Operativo',
  'repo.actions.unquarantine': 'Rimuovi quarantena',
  'repo.feedback.unquarantined': 'Quarantena rimossa.',
  'repo.feedback.confirm_unquarantine': 'Rimuovere la quarantena da questo repository?',
  'repo.errors.unquarantine_failed': 'Errore durante la rimozione della quarantena.',
  'repo.hint.quarantined': '{count} repository in quarantena: verifica le credenziali o la connettivita, poi rimuovi la quarantena manualmente.',
  'repo.errors.unsupported': 'Tipo repository non supportato.',
  'repo.errors.name_required': 'Nome repository obbligatorio.',
  'repo.errors.missing_fields': 'Compila i campi obbligatori: {fields}',
  'repo.errors.load_failed': 'Errore caricando i repository.',
  'repo.errors.create_failed': 'Creazione repository fallita.',
  'repo.feedback.created': 'Repository creato.',
  'repo.feedback.updated': 'Repository aggiornato.',
  'repo.feedback.edit_mode': 'Modifica del repository "{name}". Lascia vuoti i campi sensibili per conservare le credenziali attuali.',
  'repo.feedback.no_permission': 'Non hai i permessi per creare repository.',
  'repo.table.config': 'Configurazione',
  'repo.feedback.confirm_delete': 'Eliminare questo repository?',
  'repo.errors.update_failed': 'Aggiornamento repository fallito.',
  'repo.errors.sftp_host': 'Host SFTP non valido (usa solo lettere/numeri, punto, trattino o underscore).',
  'repo.errors.sftp_port': 'Porta SFTP non valida (1-65535).',
  'repo.errors.sftp_path': 'Il percorso SFTP deve iniziare con "/".',
  'repo.errors.rest_url': 'URL REST non valido (usa http/https).',
  'repo.errors.swift_auth_url': 'auth_url Swift non valida (usa http/https).',
  'repo.errors.gs_credentials': 'Credenziali JSON Google Cloud non valide.',
  'repo.errors.rclone_remote': 'Specifica il nome del remote rclone.',
  'restore.title': 'Guida al ripristino',
  'restore.subtitle': 'Seleziona target e repository: il job esegue automaticamente il ripristino (file + import DB + hook). Le istruzioni manuali restano disponibili come fallback.',
  'restore.fields.repository': 'Repository',
  'restore.fields.note': 'Nota job',
  'restore.actions.enqueue_restore': 'Accoda job di restore',
  'restore.errors.missing_selection': 'Seleziona endpoint, repository e target.',
  'restore.errors.enqueue_failed': 'Impossibile accodare il job di restore.',
  'restore.feedback.enqueue_success': 'Job di restore accodato.',
  'restore.feedback.no_targets': 'Nessun target WordPress/MySQL disponibile per questo endpoint.',
  'restore.latest_backup.title': 'Ultimo backup rilevato',
  'restore.latest_backup.when': 'Eseguito',
  'restore.latest_backup.state': 'Stato',
  'restore.latest_backup.site_path': 'Percorso sito',
  'restore.latest_backup.none': 'Nessun backup trovato per questo target.',
  'restore.instructions.title': 'Istruzioni operative',
  'restore.instructions.select_target': 'Seleziona un target per visualizzare i passaggi di ripristino.',
  'restore.automation.title': 'Ripristino automatico',
  'restore.automation.description': 'Il job ripristina i file dal repository, sincronizza i percorsi target, importa il dump e lancia gli hook configurati.',
  'restore.plan.snapshot': 'Snapshot',
  'restore.plan.backup_job': 'Job backup di riferimento',
  'restore.plan.backup_time': 'Eseguito il',
  'restore.plan.paths': 'Percorsi ripristinati',
  'restore.plan.extra_paths': 'Percorsi extra',
  'restore.plan.hooks_pre': 'Hook pre-restore',
  'restore.plan.hooks_post': 'Hook post-restore',
  'restore.plan.none': 'Nessun piano di restore disponibile.',
  'restore.manual.title': 'Ripristino manuale / fallback',
  'restore.manual.description': 'Usa i comandi seguenti solo se vuoi verificare il restore manualmente o in casi di emergenza.',
  'restore.wordpress.step_intro': 'Ripristina file e database del sito WordPress:',
  'restore.wordpress.step_env': '1. Imposta le variabili di ambiente del repository (password Restic, credenziali storage).',
  'restore.wordpress.step_sync_files': '3. Sincronizza i file ripristinati con il percorso di produzione ({path}) dopo averli verificati.',
  'restore.wordpress.step_db': '4. Importa il dump MySQL (es. `mysql -u {db_name} -p {db_name} < dump.sql`).',
  'restore.mysql.step_intro': 'Ripristina il dump MySQL e reimportalo nel database:',
  'restore.mysql.step_env': '1. Imposta le variabili di ambiente del repository (password Restic, credenziali storage).',
  'restore.mysql.step_find_dump': '2. Esegui `restic restore ... --include "*.sql"` e individua il file `.sql` ripristinato.',
  'restore.mysql.step_import': '3. Importa il dump (es. `mysql -u root -p {db_name} < percorso/dump.sql`).',
  'target.type.directory': 'Directory locale',
  'target.type.directory.desc': 'Esegui il backup di una o piu directory locali con restic.',
  'target.type.nextcloud': 'Nextcloud',
  'target.type.nextcloud.desc': 'Esegui un backup coerente di un nodo Nextcloud (maintenance mode, dump DB, restic).',
  'target.type.postgres': 'Database PostgreSQL',
  'target.type.mongodb': 'Database MongoDB',
  'target.placeholder.dump_options': 'Parametri aggiuntivi (uno per riga)',
  'target.placeholder.mongo_uri': 'es. mongodb://user:pass@host:27017/?authSource=admin',
  'target.placeholder.mongo_db': 'Nome database (opzionale)',
  'target.type.mysql': 'Database MySQL/MariaDB',
  'target.type.mysql.desc': 'Esegue un dump mysqldump e archivia l\'output con Restic.',
  'target.type.mssql': 'Database Microsoft SQL Server',
  'target.type.mssql.desc': 'Esegue un dump coerente di Microsoft SQL Server e lo archivia con Restic.',
  'target.type.postgres.desc': 'Esegue un dump pg_dump e lo salva su Restic.',
  'target.type.mongodb.desc': 'Esegue mongodump (formato archive) e archivia il risultato con Restic.',
  'target.type.managed_db': 'Database gestito (RDS / Cloud SQL)',
  'target.type.managed_db.desc': 'Interroga RDS o Cloud SQL per ottenere un endpoint coerente e lanciare il dump tramite l\'agente.',
  'target.type.s3': 'Bucket S3 / Object storage',
  'target.type.s3.desc': 'Scarica gli oggetti dal bucket (con prefisso opzionale) e li archivia nel repository Restic.',
  'target.type.git': 'Repository Git',
  'target.type.git.desc': 'Clona un repository Git (mirror o shallow) e lo archivia con Restic.',
  'target.type.wordpress': 'WordPress',
  'target.type.wordpress.desc': 'Metti il sito in maintenance (wp-cli), esegui mysqldump e salva file/configurazione.',
  'target.type.website': 'Sito web',
  'target.type.website.desc': 'Esegui il backup di percorsi applicativi con toggle maintenance e dump multipli dei database.',
  'target.type.imap': 'Casella IMAP',
  'target.type.imap.desc': 'Scarica i messaggi via IMAP/IMAPS e li archivia con Restic.',
  'target.type.google_workspace': 'Google Workspace',
  'target.type.google_workspace.desc': 'Esegui il backup di Drive, Gmail e Calendar con un service account delegato.',
  'target.type.m365_exchange': 'Microsoft 365 Exchange',
  'target.type.m365_exchange.desc': 'Proteggi Exchange Online (mail e calendari) tramite applicazione Microsoft Graph con delega amministratore.',
  'target.type.m365_onedrive': 'Microsoft 365 OneDrive',
  'target.type.m365_onedrive.desc': 'Replica le librerie OneDrive degli utenti via Microsoft Graph con filtri su file e dimensioni.',
  'target.type.m365_sharepoint': 'Microsoft 365 SharePoint',
  'target.type.m365_sharepoint.desc': 'Proteggi siti SharePoint Online includendo versioni, librerie e liste configurabili.',
  'target.type.m365_teams': 'Microsoft 365 Teams',
  'target.type.m365_teams.desc': 'Archivia messaggi, canali, allegati e riunioni delle squadre Microsoft Teams.',
  'target.form.show_advanced': 'Mostra impostazioni avanzate',
  'target.form.hide_advanced': 'Nascondi impostazioni avanzate',
  'target.form.advanced_populated': 'Sono presenti valori nelle impostazioni avanzate',
  'target.fields.tenant_id': 'Tenant ID (Directory)',
  'target.placeholder.tenant_id': 'es. 00000000-0000-0000-0000-000000000000',
  'target.fields.client_id': 'Client ID (App)',
  'target.placeholder.client_id': 'es. 11111111-2222-3333-4444-555555555555',
  'target.fields.client_secret': 'Client secret',
  'target.placeholder.client_secret': '********',
  'target.fields.sharepoint_sites': 'Siti SharePoint',
  'target.placeholder.sharepoint_sites': 'https://contoso.sharepoint.com/sites/marketing',
  'target.helper.sharepoint_sites': 'Uno per riga o separati da virgola; accetta URL completi o ID site.',
  'target.fields.sharepoint_site_list': 'Site list JSON',
  'target.helper.sharepoint_site_list': 'JSON con site_id, libraries e lists opzionali per configurazioni avanzate.',
  'target.fields.sharepoint_include_versions': 'Includi versioni file',
  'target.fields.sharepoint_max_versions': 'Versioni massime per file',
  'target.fields.sharepoint_exclude_paths': 'Percorsi da escludere',
  'target.placeholder.sharepoint_exclude_paths': '/Shared Documents/tmp',
  'target.fields.sharepoint_include_lists': 'Liste da includere',
  'target.placeholder.sharepoint_include_lists': 'Announcements, Issues',
  'target.fields.sharepoint_library_query': 'Filtro librerie',
  'target.placeholder.sharepoint_library_query': 'es. startswith(displayName, "Doc")',
  'target.fields.teams': 'Team da includere',
  'target.placeholder.teams': 'TeamA, TeamB',
  'target.fields.team_list': 'Team list JSON',
  'target.helper.team_list': 'JSON con team_id, channels e members opzionali.',
  'target.fields.include_private_channels': 'Includi canali privati',
  'target.fields.include_chats': 'Includi chat 1:1/di gruppo',
  'target.fields.include_meetings': 'Includi riunioni',
  'target.fields.chat_user_list': 'Utenti chat (uno per riga)',
  'target.placeholder.chat_user_list': 'alice@example.com, bob@example.com',
  'target.fields.max_messages': 'Messaggi massimi',
  'target.placeholder.max_messages': 'es. 10000',
  'target.fields.max_days': 'Giorni da esportare',
  'target.placeholder.max_days': 'es. 30',
  'target.fields.exchange_mode': 'Modalità',
  'target.fields.exchange_modules': 'Moduli Exchange',
  'target.placeholder.exchange_modules': 'mail, calendar',
  'target.helper.exchange_modules': 'Lascia vuoto per mail + calendar. Usa virgole per limitarli.',
  'target.m365_sharepoint.errors.sites_required': 'Specifica almeno un sito o un elenco JSON.',
  'target.m365_sharepoint.errors.max_versions': 'Versioni massime deve essere un intero positivo.',
  'target.m365_sharepoint.errors.site_list_invalid': 'Il campo Site list deve contenere JSON valido.',
  'target.m365_teams.errors.selection_required': 'Configura almeno un team o abilita il backup chat.',
  'target.m365_teams.errors.team_list_invalid': 'Il campo Team list deve contenere JSON valido.',
  'target.m365_teams.errors.positive_integer': '{field} deve essere un intero positivo.',
  'target.fields.exchange_scopes': 'Scopes Microsoft Graph',
  'target.placeholder.exchange_scopes': 'https://graph.microsoft.com/.default, offline_access',
  'target.helper.exchange_scopes': 'Lascia vuoto per usare https://graph.microsoft.com/.default. Aggiungi altri scopes separandoli da virgole o righe.',
  'target.fields.authority_host': 'Authority host',
  'target.placeholder.authority_host': 'https://login.microsoftonline.com',
  'target.helper.authority_host': 'Solo per cloud sovrani (es. https://login.microsoftonline.us).',
  'target.fields.mail_query': 'Filtro messaggi',
  'target.placeholder.mail_query': 'es. received>=2024-01-01',
  'target.helper.mail_query': 'Facoltativo: filtro OData per i messaggi (Graph).',
  'target.fields.calendar_query': 'Filtro calendario',
  'target.placeholder.calendar_query': 'es. start/dateTime ge 2024-01-01T00:00:00Z',
  'target.helper.calendar_query': 'Facoltativo: filtro OData per gli eventi (Graph).',
  'target.fields.max_parallel_exports': 'Export paralleli massimi',
  'target.placeholder.max_parallel_exports': 'es. 4',
  'target.fields.site_path': 'Percorso sito',
  'target.placeholder.site_path': '/var/www/html',
  'target.fields.wp_cli_cmd': 'Comando wp-cli',
  'target.placeholder.wp_cli_cmd': 'es. sudo -u www-data wp --path=/var/www/html',
  'target.helper.wp_cli_cmd': 'Facoltativo, usato per maintenance-mode activate/deactivate.',
  'target.fields.dump_options': 'Opzioni dump',
  'target.helper.dump_options': 'Esempio: --single-transaction oppure --no-owner.',
  'target.fields.mongo_uri': 'URI MongoDB',
  'target.fields.mongo_db': 'Database MongoDB',
  'target.fields.dump_args': 'Parametri mongodump',
  'target.placeholder.dump_args': 'Opzioni aggiuntive per mongodump',
  'target.helper.dump_args': 'Esempio: --gzip oppure --collection=mia_collezione.',
  'target.fields.paths': 'Percorsi',
  'target.placeholder.paths': 'Una directory per riga oppure separata da virgole',
  'target.fields.exclude': 'Escludi',
  'target.placeholder.exclude': 'Pattern da escludere (uno per riga)',
  'target.fields.tags': 'Tag restic',
  'target.placeholder.tags': 'tag1, tag2',
  'target.fields.note': 'Nota',
  'target.placeholder.note': 'Nota opzionale',
  'target.placeholder.imap_host': 'imap.example.com',
  'target.placeholder.imap_port': 'es. 993',
  'target.placeholder.imap_username': 'utente@example.com',
  'target.placeholder.imap_password': 'password o app password',
  'target.placeholder.imap_mailboxes': 'INBOX\nSent',
  'target.helper.imap_mailboxes': 'Una cartella per riga; lascia vuoto per INBOX',
  'target.placeholder.imap_max_messages': 'es. 100 (vuoto = tutti)',
  'target.fields.workspace_mode': 'Modalità',
  'target.options.workspace_mode.single': 'Utente singolo',
  'target.options.workspace_mode.list': 'Lista utenti',
  'target.options.workspace_mode.group': 'Gruppo',
  'target.fields.primary_user': 'Utente principale',
  'target.placeholder.primary_user': 'utente@example.com',
  'target.fields.user_list': 'Lista utenti',
  'target.placeholder.user_list': 'user1@example.com\nuser2@example.com',
  'target.helper.user_list': 'Uno per riga; sono accettate anche virgole o punto e virgola.',
  'target.fields.group_email': 'Email gruppo',
  'target.placeholder.group_email': 'gruppo@example.com',
  'target.fields.admin_user': 'Account admin delega',
  'target.placeholder.admin_user': 'admin@example.com',
  'target.fields.workspace_modules': 'Moduli',
  'target.placeholder.workspace_modules': 'drive, gmail, calendar',
  'target.helper.workspace_modules': 'Lascia vuoto per tutti i moduli supportati oppure separa con virgole.',
  'target.fields.service_account_json': 'Service account JSON',
  'target.placeholder.service_account_json': '{ "type": "service_account", ... }',
  'target.helper.service_account_json': 'Incolla il JSON del service account con delega domain-wide attiva.',
  'target.fields.drive_include_shared': 'Includi file condivisi',
  'target.helper.drive_include_shared': 'Se disattivi, i file condivisi con l\'utente principale vengono esclusi.',
  'target.fields.drive_query': 'Query Drive',
  'target.placeholder.drive_query': 'es. modifiedTime > "2024-01-01T00:00:00Z"',
  'target.helper.drive_query': 'Facoltativo: usa la sintassi di ricerca Drive per filtrare i file.',
  'target.fields.drive_max_files': 'Max file Drive',
  'target.placeholder.drive_max_files': 'es. 1000',
  'target.fields.onedrive_max_files': 'Limite file OneDrive',
  'target.placeholder.onedrive_max_files': 'es. 5000',
  'target.helper.onedrive_max_files': 'Ferma l\'export dopo aver raggiunto questo numero di file.',
  'target.fields.onedrive_max_bytes': 'Limite byte OneDrive',
  'target.placeholder.onedrive_max_bytes': 'es. 2147483648',
  'target.helper.onedrive_max_bytes': 'Interrompe l\'export quando la soglia di byte viene superata.',
  'target.fields.onedrive_exclude_extensions': 'Estensioni da escludere',
  'target.placeholder.onedrive_exclude_extensions': 'es. tmp,log,bak',
  'target.helper.onedrive_exclude_extensions': 'Separale con virgole o righe; non includere il punto iniziale.',
  'target.fields.gmail_query': 'Query Gmail',
  'target.placeholder.gmail_query': 'es. newer_than:30d',
  'target.helper.gmail_query': 'Facoltativo: query di ricerca Gmail (stessa sintassi della webmail).',
  'target.fields.gmail_label': 'Label Gmail',
  'target.placeholder.gmail_label': 'Backup',
  'target.fields.gmail_max_messages': 'Max messaggi Gmail',
  'target.placeholder.gmail_max_messages': 'es. 5000',
  'target.fields.calendar_time_min': 'Calendario da',
  'target.fields.calendar_time_max': 'Calendario a',
  'target.placeholder.calendar_time_min': '2024-01-01T00:00:00Z',
  'target.placeholder.calendar_time_max': '2024-12-31T23:59:59Z',
  'target.fields.calendar_max_events': 'Max eventi Calendario',
  'target.placeholder.calendar_max_events': 'es. 5000',
  'target.helper.calendar_time': 'ISO 8601 (es. 2024-01-01T00:00:00Z); lascia vuoto per includere tutto l\'intervallo.',
  'target.fields.nc_path': 'Percorso Nextcloud',
  'target.placeholder.nc_path': '/var/www/nextcloud',
  'target.fields.data_path': 'Cartella dati',
  'target.placeholder.data_path': '/var/nc-data',
  'target.fields.extra_paths': 'Percorsi extra',
  'target.placeholder.extra_paths': 'Percorsi aggiuntivi (uno per riga)',
  'target.helper.extra_paths': 'Facoltativo: percorsi extra da includere, uno per riga.',
  'target.fields.occ_cmd': 'Comando occ',
  'target.placeholder.occ_cmd': 'es. sudo -u www-data php /var/www/nextcloud/occ',
  'target.helper.occ_cmd': 'Lascia vuoto per usare "php <nc_path>/occ".',
  'target.fields.db_type': 'Database',
  'target.options.db_type.mysql': 'MySQL / MariaDB',
  'target.options.db_type.postgres': 'PostgreSQL',
  'target.options.boolean.true': 'Yes',
  'target.options.boolean.false': 'No',
  'target.fields.db_host': 'Host DB',
  'target.placeholder.db_host': 'localhost',
  'target.fields.db_port': 'Porta DB',
  'target.placeholder.db_port': 'es. 3306',
  'target.placeholder.db_port_mysql': 'es. 3306',
  'target.placeholder.db_port_mssql': 'es. 1433',
  'target.placeholder.db_port_postgres': 'es. 5432',
  'target.fields.db_socket': 'Socket DB',
  'target.placeholder.db_socket': '/var/run/mysqld/mysqld.sock',
  'target.placeholder.db_socket_mysql': '/var/run/mysqld/mysqld.sock',
  'target.placeholder.db_socket_postgres': '/var/run/postgresql/.s.PGSQL.5432',
  'target.fields.db_name': 'Nome DB',
  'target.placeholder.db_name': 'nextcloud',
  'target.fields.db_user': 'Utente DB',
  'target.fields.db_username': 'Utente DB',
  'target.placeholder.db_user': 'nc_user',
  'target.placeholder.db_username': 'admin',
  'target.fields.db_password': 'Password DB',
  'target.placeholder.db_password': 'password',
  'target.fields.db_instance': 'Istanza SQL Server',
  'target.placeholder.db_instance': 'es. SQLEXPRESS',
  'target.helper.db_instance': 'Facoltativo: indica l\'istanza se diversa da quella predefinita.',
  'target.fields.trust_server_certificate': 'Accetta certificato server',
  'target.helper.trust_server_certificate': 'Usa "Sì" solo in ambienti con certificati self-signed o non validati.',
  'target.fields.managed_provider': 'Provider managed DB',
  'target.fields.db_engine': 'Engine database',
  'target.fields.instance_id': 'ID istanza',
  'target.placeholder.instance_id': 'es. rds-instance-1',
  'target.fields.region': 'Regione',
  'target.placeholder.region': 'es. eu-west-1',
  'target.fields.project_id': 'Project ID',
  'target.placeholder.project_id': 'es. progetto-gcp',
  'target.fields.aws_access_key_id': 'AWS access key ID',
  'target.placeholder.aws_access_key_id': 'AKIA...',
  'target.fields.aws_secret_access_key': 'AWS secret access key',
  'target.placeholder.aws_secret_access_key': '********',
  'target.fields.aws_session_token': 'AWS session token',
  'target.placeholder.aws_session_token': 'Token temporaneo (opzionale)',
  'target.fields.bucket': 'Bucket',
  'target.placeholder.bucket': 'es. backup-production',
  'target.fields.prefix': 'Prefisso',
  'target.placeholder.prefix': 'es. exports/',
  'target.helper.s3_prefix': 'Limita il download agli oggetti che iniziano con il prefisso indicato (niente slash iniziale).',
  'target.fields.endpoint': 'Endpoint S3',
  'target.placeholder.endpoint': 'es. https://s3.eu-west-1.amazonaws.com',
  'target.helper.s3_endpoint': 'Lascia vuoto per AWS; imposta l\'URL per endpoint compatibili (MinIO, Ceph...).',
  'target.fields.include_glacier': 'Includi Glacier/Archive',
  'target.helper.include_glacier': 'Scarica anche oggetti in Glacier / Deep Archive (richiede restore preventivo, può fallire).',
  'target.fields.force_path_style': 'Forza path-style',
  'target.helper.force_path_style': 'Usa richieste path-style (necessario per MinIO o storage compatibili).',
  'target.fields.use_accelerate_endpoint': 'Usa endpoint accelerate',
  'target.helper.use_accelerate_endpoint': 'Abilita Transfer Acceleration per bucket AWS configurati.',
  'target.fields.object_limit': 'Limite oggetti',
  'target.placeholder.object_limit': 'es. 1000',
  'target.helper.object_limit': 'Interrompe il download dopo il numero indicato di oggetti (utile per test).',
  'target.fields.max_total_bytes': 'Limite totale byte',
  'target.placeholder.max_total_bytes': 'es. 1073741824',
  'target.helper.max_total_bytes': 'Ferma il download quando la soglia di byte viene raggiunta per evitare bucket enormi.',
  'target.fields.gcp_service_account': 'Service account JSON',
  'target.placeholder.gcp_service_account': '{ ... }',
  'target.helper.gcp_service_account': 'Incolla il JSON completo del service account con permessi Cloud SQL Admin.',
  'target.fields.use_private_ip': 'Usa IP privato',
  'target.options.managed_provider.aws_rds': 'AWS RDS',
  'target.options.managed_provider.gcp_cloudsql': 'GCP Cloud SQL',
  'target.managed_db.errors.provider_required': 'Seleziona un provider managed DB.',
  'target.managed_db.errors.engine_required': 'Seleziona l\'engine del database.',
  'target.managed_db.errors.aws_missing': 'Campi AWS mancanti: {fields}',
  'target.managed_db.errors.gcp_missing': 'Campi Cloud SQL mancanti: {fields}',
  'target.managed_db.errors.gcp_service_account_invalid': 'Il service account JSON non è valido.',
  'target.google_workspace.errors.mode_required': 'Seleziona una modalità valida (single, list, group).',
  'target.google_workspace.errors.service_account': 'Inserisci il JSON del service account.',
  'target.google_workspace.errors.service_account_invalid': 'Il service account JSON non è valido.',
  'target.google_workspace.errors.modules_invalid': 'Modulo non supportato: {value}. Usa drive, gmail o calendar.',
  'target.google_workspace.errors.modules_required': 'Seleziona almeno un modulo supportato.',
  'target.google_workspace.errors.email_required': 'Il campo {field} è obbligatorio.',
  'target.google_workspace.errors.email_invalid': 'Il campo {field} deve contenere un indirizzo email valido.',
  'target.google_workspace.errors.user_list_required': 'Per la modalità lista inserisci almeno un indirizzo email.',
  'target.google_workspace.errors.user_list_entry': 'Indirizzo non valido nella lista utenti: {value}.',
  'target.google_workspace.errors.positive_integer': 'Il campo {field} deve essere un intero positivo.',
  'target.google_workspace.errors.datetime': 'Il campo {field} deve essere una data/ora ISO 8601 valida.',
  'target.m365_exchange.errors.mode_required': 'Seleziona una modalità valida (single, list, group).',
  'target.m365_exchange.errors.modules_invalid': 'Modulo non supportato: {value}. Usa mail o calendar.',
  'target.m365_exchange.errors.email_required': 'Il campo {field} è obbligatorio.',
  'target.m365_exchange.errors.email_invalid': 'Il campo {field} deve contenere un indirizzo email valido.',
  'target.m365_exchange.errors.user_list_required': 'Per la modalità lista inserisci almeno un indirizzo email.',
  'target.m365_exchange.errors.user_list_entry': 'Indirizzo non valido nella lista utenti: {value}.',
  'target.m365_exchange.errors.positive_integer': 'Il campo {field} deve essere un intero positivo.',
  'target.m365_onedrive.errors.mode_required': 'Seleziona una modalità valida (single, list, group).',
  'target.m365_onedrive.errors.email_required': 'Il campo {field} è obbligatorio.',
  'target.m365_onedrive.errors.email_invalid': 'Il campo {field} deve contenere un indirizzo email valido.',
  'target.m365_onedrive.errors.user_list_required': 'Per la modalità lista inserisci almeno un indirizzo email.',
  'target.m365_onedrive.errors.user_list_entry': 'Indirizzo non valido nella lista utenti: {value}.',
  'target.m365_onedrive.errors.positive_integer': 'Il campo {field} deve essere un intero positivo.',
  'target.s3.errors.credentials_pair': 'Compila sia access key che secret key, oppure lascia entrambi i campi vuoti (usa IAM/ruolo).',
  'target.s3.errors.object_limit': 'Il limite oggetti deve essere un intero positivo.',
  'target.s3.errors.max_total_bytes': 'Il limite di byte totali deve essere un intero positivo.',
  'target.fields.git_remote_url': 'URL repository',
  'target.placeholder.git_remote_url': 'https://git.example.com/org/repo.git',
  'target.fields.git_auth_method': 'Metodo autenticazione',
  'target.helper.git_auth_method': 'Auto seleziona il metodo in base alle credenziali presenti; scegli manualmente per forzare un tipo specifico.',
  'target.options.git_auth.auto': 'Automatico',
  'target.options.git_auth.none': 'Nessuno (pubblico)',
  'target.options.git_auth.token': 'Token HTTP',
  'target.options.git_auth.basic': 'Basic (username/password)',
  'target.options.git_auth.ssh': 'SSH con chiave',
  'target.fields.git_token_username': 'Username token',
  'target.placeholder.git_token_username': 'es. oauth2',
  'target.helper.git_token_username': 'Facoltativo: sovrascrive lo username usato insieme al token.',
  'target.fields.git_token': 'Token',
  'target.placeholder.git_token': 'ghp_xxxxx',
  'target.helper.git_token': 'Incolla un personal access token o deploy token con permessi di lettura.',
  'target.fields.git_username': 'Username',
  'target.placeholder.git_username': 'git-user',
  'target.fields.git_password': 'Password',
  'target.placeholder.git_password': 'password',
  'target.helper.git_basic': 'Compila username/password per autenticazione HTTP Basic.',
  'target.fields.git_ssh_private_key': 'Chiave privata SSH',
  'target.placeholder.git_ssh_private_key': '-----BEGIN OPENSSH PRIVATE KEY-----',
  'target.helper.git_ssh_private_key': 'Chiave PEM senza passphrase; verrà salvata localmente sul job in modo temporaneo.',
  'target.fields.git_ssh_known_hosts': 'Known hosts',
  'target.placeholder.git_ssh_known_hosts': 'git.example.com ssh-ed25519 AAAA...',
  'target.helper.git_known_hosts': 'Facoltativo: elenco delle righe known_hosts da imporre per la verifica SSH.',
  'target.fields.git_mirror': 'Clona mirror',
  'target.helper.git_mirror': 'Il mirror scarica tutti i riferimenti remoti. Disattivalo per un clone standard con working tree.',
  'target.fields.git_depth': 'Depth (shallow)',
  'target.placeholder.git_depth': 'es. 100',
  'target.helper.git_depth': 'Valore > 0 per un clone shallow (solo quando mirror è disattivato).',
  'target.fields.tmp_dir': 'Directory temporanea',
  'target.placeholder.tmp_dir': '/tmp',
  'target.fields.maintenance_enabled': 'Maintenance abilitata',
  'target.fields.maintenance_on_cmd': 'Comando maintenance ON',
  'target.fields.maintenance_off_cmd': 'Comando maintenance OFF',
  'target.placeholder.maintenance_on_cmd': 'es. sudo -u www-data ./maintenance-on.sh',
  'target.placeholder.maintenance_off_cmd': 'es. sudo -u www-data ./maintenance-off.sh',
  'target.helper.maintenance_on_cmd': 'Eseguito prima del backup quando la maintenance è attiva.',
  'target.helper.maintenance_off_cmd': 'Eseguito dopo il backup per ripristinare il servizio.',
  'target.fields.databases': 'Database aggiuntivi',
  'target.placeholder.databases': '[{"type":"mysql","db_name":"app","db_user":"user","db_password":"***"}]',
  'target.helper.databases': 'Gestisci qui i database aggiuntivi: usa "Aggiungi database" per ognuno e compila i campi richiesti.',
  'target.website.database_hint': 'Compila i database aggiuntivi senza scrivere JSON: saranno serializzati automaticamente.',
  'target.website.buttons.add_db': 'Aggiungi database',
  'target.website.buttons.remove_db': 'Rimuovi database',
  'target.website.database_label': 'Database {index}',
  'target.website.errors.database_required': 'Specifica almeno un database aggiuntivo oppure compila i campi database principali.',
  'target.fields.exclude_paths': 'Escludi percorsi',
  'target.placeholder.exclude_paths': 'Pattern da escludere (uno per riga)',
  'target.fields.include_cache': 'Includi cache/previews',
  'target.fields.imap_host': 'Host IMAP',
  'target.fields.imap_port': 'Porta IMAP',
  'target.fields.imap_use_ssl': 'Usa SSL',
  'target.fields.imap_username': 'Utente IMAP',
  'target.fields.imap_password': 'Password IMAP',
  'target.fields.imap_mailboxes': 'Cartelle',
  'target.fields.imap_max_messages': 'Limite messaggi (debug)',
  'target.summary.google_workspace': 'Modalità {mode} • Moduli {modules} • Utenti {users}',
  'target.summary.m365_exchange': 'Modalità {mode} • Moduli {modules} • Mailbox {mailboxes}',
  'target.summary.m365_onedrive': 'Modalità {mode} • Utenti {users}',
  'target.summary.onedrive_files': 'File esportati: {value}',
  'target.summary.onedrive_bytes': 'Byte esportati: {value}',
  'target.summary.onedrive_shared': 'Condivisi inclusi: {value}',
  'target.summary.onedrive_query': 'Query: {value}',
  'target.summary.onedrive_excludes': 'Esclusioni: {value}',
  'target.summary.onedrive_max_files': 'Limite file: {value}',
  'target.summary.onedrive_max_bytes': 'Limite byte: {value}',
  'target.summary.sharepoint_sites': 'Siti: {value}',
  'target.summary.sharepoint_libraries': 'Librerie: {value}',
  'target.summary.sharepoint_files': 'File: {value}',
  'target.summary.sharepoint_bytes': 'Byte: {value}',
  'target.summary.teams_processed': 'Team: {value}',
  'target.summary.teams_channels': 'Canali: {value}',
  'target.summary.teams_messages': 'Messaggi: {value}',
  'target.summary.teams_attachments': 'Allegati: {value}',
  'target.summary.teams_meetings': 'Riunioni: {value}',
  'target.summary.sample_user': 'Utente campione: {value}',
  'target.summary.sample_mailbox': 'Mailbox campione: {value}',
  'target.summary.group': 'Gruppo: {value}',
  'target.summary.admin': 'Admin: {value}',
  'target.summary.secrets': 'Credenziali target archiviate in modo sicuro',
  'target.table.config': 'Configurazione',
  'target.feedback.no_permission': 'Non hai i permessi per creare targets.',
  'target.feedback.confirm_delete': 'Eliminare questo target?',
  'target.feedback.edit_mode': 'Modifica il target "{name}". Lascia vuoti i campi segreti per mantenere i valori attuali.',
  'target.feedback.secret_hint': 'Lascia vuoto per mantenere il valore attuale.',
  'target.feedback.no_changes': 'Nessuna modifica da salvare.',
  'target.errors.name_required': 'Nome target obbligatorio.',
  'target.errors.unsupported': 'Tipo target non supportato.',
  'target.errors.missing_fields': 'Compila i campi obbligatori: {fields}',
  'target.git.errors.token_required': 'Per il metodo token inserisci un token valido.',
  'target.git.errors.basic_required': 'Per il metodo basic compila username e password.',
  'target.git.errors.ssh_required': 'Per il metodo SSH incolla una chiave privata senza passphrase.',
  'target.errors.create_failed': 'Creazione target fallita.',
  'target.placeholder.select': 'Seleziona',
  'agents.errors.load': 'Errore caricando gli agenti',
  'agents.errors.installer': 'Errore generando lo script di installazione',
  'agents.errors.docker': 'Errore generando il comando Docker',
  'agents.feedback.docker_copy': 'Comando Docker copiato negli appunti',
  'agents.confirm.rotate': 'Ruotare la chiave per l\'agent #{id}?',
  'agents.feedback.new_key': 'Nuova chiave',
  'agents.feedback.key_hint': '(vedi risposta)',
  'agents.confirm.delete': 'Eliminare l\'agent #{id}?',
  'agents.mode.paused': 'In pausa',
  'agents.mode.simulate': 'Simulazione',
  'agents.mode.real': 'Esecuzione reale',
  'agents.table.mode': 'Modalita',
  'agents.actions.resume': 'Riprendi',
  'agents.actions.pause': 'Metti in pausa',
  'agents.actions.set_real': 'Passa a reale',
  'agents.actions.set_simulate': 'Passa a simulazione',
  'agents.actions.installer': 'Installer Linux',
  'agents.actions.rotate': 'Ruota chiave',
  'agents.actions.delete': 'Elimina',
  'agents.feedback.mode_updated': 'Modalita agente aggiornata.',
  'agents.errors.mode_update': 'Impossibile aggiornare la modalita agente.',
  'help.jobs': 'Elenco dei job (backup, check, prune, restore). Usa i filtri per stato, endpoint, tipo e intervallo date; cerca nel payload/note. Puoi avviare un backup manuale e scaricare i risultati in CSV.',
  'jobs.errors.endpoint_required': 'Seleziona un endpoint.',
  'jobs.errors.repository_required': 'Seleziona un repository.',
  'jobs.errors.target_required': 'Seleziona un target.',
  'jobs.feedback.enqueued': 'Job in coda.',
  'jobs.errors.enqueue_failed': 'Impossibile accodare il job.',
  'jobs.errors.repo_quarantined': 'Repository in quarantena: abilita il force o ripristina la connettivita.',
  'jobs.fields.allow_quarantined': 'Forza esecuzione nonostante la quarantena',
  'jobs.fields.backup_mode': 'ModalitÃÂ  backup',
  'jobs.fields.mode': 'ModalitÃÂ ',
  'jobs.fields.snapshot': 'Snapshot',
  'jobs.fields.chain': 'Catena',
  'jobs.mode.policy': 'Da policy',
  'jobs.mode.full': 'Completo',
  'jobs.mode.differential': 'Differenziale',
  'jobs.mode.incremental': 'Incrementale',
  'jobs.mode.log': 'Log transazionale',
  'jobs.hint.repo_quarantined': 'Il repository selezionato e in quarantena: verifica credenziali, raggiungibilita e costi prima di forzare il backup.',
  'home.size.title': 'Trend dimensione backup',
  'home.size.no_data': 'Nessun dato disponibile',
  'home.size.anomalies': 'Anomalie recenti',
  'home.size.view_job': 'Apri job',
  'home.size.anomalies_more': '+{count} altre anomalie',
  'jobs.placeholder.endpoint': 'Seleziona endpoint',
  'jobs.placeholder.repository': 'Seleziona repository',
  'jobs.placeholder.target': 'Seleziona target',
  'help.rbac': 'Gestisci ruoli e permessi per tenant. Seleziona un utente e un ruolo per assegnarlo al tenant attivo. I ruoli controllano le azioni disponibili.',
  'help.health': 'Stato dei servizi (DB, Redis, OIDC). Se un servizio non A  OK, usa i dettagli per la diagnostica.',
  'policy.kpi.type.full_age': 'Last full age',
  'policy.kpi.fields.max_age_hours': 'Max hours since full',
  'policy.kpi.add_full': 'Add full-age rule',
}

const EN_DICT: Dict = {
  'common.loading': 'Loading...',
  'nav.menu': 'Menu',
  'nav.settings': 'Settings',
  'nav.home': 'Home',
  'nav.tenants': 'Tenants',
  'nav.endpoints': 'Endpoints',
  'nav.policies': 'Policies',
  'nav.schedules': 'Schedules',
  'nav.repos': 'Repositories',
  'nav.jobs': 'Jobs',
  'nav.rbac': 'RBAC',
  'nav.health': 'Health',
  'nav.restore': 'Restore',
  'settings.version': 'Software version',
  'settings.monitoring.title': 'Monitoring & Alerting',
  'settings.monitoring.subtitle': 'Configure Prometheus Pushgateway and ELK stack destinations for metrics and logs.',
  'settings.monitoring.updated_at': 'Updated',
  'settings.monitoring.enabled': 'Enable global monitoring',
  'settings.monitoring.enabled_hint': 'Disable to pause all exports while keeping provider settings.',
  'settings.monitoring.prometheus': 'Prometheus',
  'settings.monitoring.prometheus.pushgateway': 'Pushgateway URL',
  'settings.monitoring.prometheus.remote_write': 'Remote write URL',
  'settings.monitoring.prometheus.job': 'Job name',
  'settings.monitoring.prometheus.user': 'Basic auth user',
  'settings.monitoring.prometheus.password': 'Basic auth password',
  'settings.monitoring.prometheus.password_set': 'Password already stored: leave empty to keep it.',
  'settings.monitoring.prometheus.password_clear': 'Clear stored password',
  'settings.monitoring.elk': 'Elastic / ELK',
  'settings.monitoring.elk.endpoint': 'Endpoint',
  'settings.monitoring.elk.index': 'Index pattern',
  'settings.monitoring.elk.username': 'Username / API key ID',
  'settings.monitoring.elk.password': 'Password / API key',
  'settings.monitoring.elk.password_set': 'Credential already stored: leave empty to keep it.',
  'settings.monitoring.elk.password_clear': 'Clear stored credential',
  'settings.monitoring.save': 'Save monitoring settings',
  'header.hi': 'Hi,',
  'landing.title': 'Welcome to the SaaS backup console',
  'landing.subtitle': 'Centralised backup, restore and monitoring control',
  'landing.body': 'Sign in to protect tenants, monitor jobs and react quickly to alerts.',
  'landing.feature.monitor': 'Real-time visibility on jobs, queues and critical services.',
  'landing.feature.restore': 'Guided restore workflows to minimise downtime.',
  'landing.feature.audit': 'Full audit trail of actions for compliance readiness.',
  'landing.notice': 'Access restricted to authorised administrators only.',
  'buttons.login': 'Login',
  'buttons.logout': 'Logout',
  'buttons.run_backup': 'Run Backup',
  'buttons.export_csv': 'Export CSV',
  'buttons.create': 'Create',
  'buttons.add': 'Add',
  'buttons.delete': 'Delete',
  'buttons.enable': 'Enable',
  'buttons.disable': 'Disable',
  'buttons.edit': 'Edit',
  'buttons.save': 'Save',
  'buttons.cancel': 'Cancel',
  'titles.tenants': 'Tenants',
  'titles.endpoints': 'Endpoints',
  'titles.targets_for': 'Targets for endpoint {id}',
  'titles.policies': 'Policies',
  'titles.schedules': 'Schedules',
  'titles.repos': 'Repositories',
  'titles.jobs': 'Jobs',
  'titles.rbac': 'RBAC Management',
  'titles.health': 'Health',
  'help.tenants': 'Tenants represent organizations/logical scopes. Use the selector above to choose the current tenant. Admins can see available tenants here.',
  'help.endpoints': 'Endpoints are servers/instances where the backup agent runs. Register a new endpoint, then add targets for what you want to protect. The agent should be enrolled.',
  'endpoints.errors.name_required': 'Name is required.',
  'endpoints.errors.create_failed': 'Failed to create endpoint.',
  'endpoints.errors.no_permission': 'You do not have permission to create endpoints.',
  'endpoints.actions.install': 'Install agent',
  'endpoints.actions.delete_confirm': 'Delete endpoint #{id}? Linked targets/agents/schedules will be removed.',
  'endpoints.table.preflight': 'Preflight',
  'endpoints.installer.title': 'Installer for {name}',
  'endpoints.installer.hint': 'Generate a temporary token and copy the systemd script or Docker command to run on the endpoint host.',
  'endpoints.installer.minutes': 'Validity (minutes)',
  'endpoints.installer.generate': 'Regenerate',
  'endpoints.installer.error': 'Unable to generate installer. Please try again.',
  'endpoints.installer.script': 'Linux script (systemd)',
  'endpoints.installer.docker': 'Docker command',
  'help.targets': 'Targets define what to protect (e.g., Nextcloud or a directory). Add one or more targets per endpoint. Policies/schedules decide when backups run.',
  'help.policies': 'Policies define how (retention) and when (schedule) to run backups, plus notify/verification options. Attach policies to endpoints via Schedules.',
  'stateful.heading': 'Stateful retention rules',
  'stateful.help': 'Configure rules to keep snapshots tied to specific mailboxes or Restic tags. Separate multiple patterns with commas or semicolons.',
  'stateful.add': 'Add rule',
  'stateful.description': 'Description (optional)',
  'stateful.mailbox': 'Mailbox or pattern (e.g. Archive*)',
  'stateful.tag': 'Restic tag (optional)',
  'stateful.keep_last': 'Keep last (snapshots)',
  'stateful.keep_within': 'Keep within (e.g. 90d)',
  'stateful.none': 'No rules yet',
  'stateful.remove': 'Remove',
  'stateful.hint': 'Use comma or semicolon to separate multiple values. Leave Keep last empty to rely on automatic keep-tag pinning.',
  'policy.strategy': 'Backup strategy',
  'policy.strategy.full': 'Full',
  'policy.strategy.differential': 'Differential',
  'policy.strategy.incremental': 'Incremental',
  'policy.strategy.log': 'Log',
  'policy.max_non_full': 'Max non-full backups',
  'policy.full_interval': 'Full interval',
  'policy.kpi.title': 'KPI automation',
  'policy.kpi.empty': 'No KPI rules configured.',
  'policy.kpi.fields.type': 'Type',
  'policy.kpi.fields.label': 'Label',
  'policy.kpi.fields.label_ph': 'Optional description',
  'policy.kpi.fields.severity': 'Severity',
  'policy.kpi.fields.cooldown': 'Cooldown (min)',
  'policy.kpi.type.size': 'Size change',
  'policy.kpi.type.failure': 'Failure streak',
  'policy.kpi.fields.threshold_percent': 'Threshold %',
  'policy.kpi.fields.window': 'Consecutive samples',
  'policy.kpi.fields.direction': 'Direction',
  'policy.kpi.direction.increase': 'Increase',
  'policy.kpi.direction.decrease': 'Decrease',
  'policy.kpi.direction.both': 'Both',
  'policy.kpi.fields.threshold_fail': 'Consecutive failures',
  'policy.kpi.fields.resume': 'Auto resume (min)',
  'policy.kpi.actions.force_full': 'Force full backup',
  'policy.kpi.actions.pause': 'Auto pause schedule',
  'policy.kpi.actions.extend_keep': 'Extend keep-last',
  'policy.kpi.fields.keep_min': 'Min keep',
  'policy.kpi.fields.keep_inc': 'Increase',
  'policy.kpi.fields.keep_duration': 'Duration (hours)',
  'policy.kpi.actions.notify': 'Send notification',
  'policy.kpi.severity.info': 'Info',
  'policy.kpi.severity.warning': 'Warning',
  'policy.kpi.severity.critical': 'Critical',
  'policy.kpi.add_size': 'Add size rule',
  'policy.kpi.add_failure': 'Add failure rule',
  'policy.kpi.column': 'KPI rules',
  'policy.freeze.title': 'Freeze windows',
  'policy.freeze.empty': 'No freeze windows configured.',
  'policy.freeze.fields.days': 'Days (e.g. mon-fri)',
  'policy.freeze.fields.start': 'Start',
  'policy.freeze.fields.end': 'End',
  'policy.freeze.add': 'Add freeze window',
  'policy.freeze.hint': 'Schedules are paused during these windows to avoid running backups.',
  'policy.freeze.column': 'Freeze windows',
  'help.schedules': 'Schedules link an endpoint to a policy and enable automatic runs. You can enable/disable and remove schedules.',
  'schedule.fields.policy': 'Policy',
  'schedule.fields.repository': 'Repository',
  'schedule.fields.target': 'Target',
  'schedule.table.policy': 'Policy',
  'schedule.table.repository': 'Repository',
  'schedule.table.target': 'Target',
  'schedule.table.last_success': 'Last successful backup',
  'schedule.table.last_check': 'Last verification',
  'schedule.table.last_restore': 'Last test restore',
  'schedule.table.status': 'Status',
  'schedule.table.next_run': 'Next run',
  'schedule.status.paused': 'Schedule paused',
  'schedule.status.resume': 'Resumes on {value}',
  'schedule.status.kpi_triggered': 'KPI rule triggered',
  'schedule.status.preflight_required': 'Preflight required',
  'schedule.status.preflight_prefix': 'Preflight',
  'schedule.status.ok': 'OK',
  'schedule.status.next_force_full': 'Next run will be a full backup',
  'schedule.actions.force_full': 'Force next full',
  'preflight.actions.run': 'Run preflight',
  'preflight.status.never': 'Never run',
  'preflight.feedback.queued': 'Preflight enqueued',
  'preflight.errors.failed': 'Preflight failed',
  'schedule.errors.targets_load_failed': 'Failed to load targets for endpoint.',
  'schedule.errors.missing_fields': 'Select endpoint, policy, repository and target.',
  'schedule.errors.create_failed': 'Failed to create schedule.',
  'schedule.feedback.created': 'Schedule created.',
  'schedule.feedback.no_permission': 'You do not have permission to create schedules.',
  'schedule.feedback.confirm_delete': 'Delete this schedule?',
  'schedule.feedback.force_full': 'Next backup will run as full.',
  'schedule.errors.force_full_failed': 'Unable to force the next full backup.',
  'help.repos': 'Repositories are backup destinations (e.g., S3, Local, B2, Azure). Create per-tenant repositories; jobs will use them as configured.',
  'repo.type.s3': 'Amazon S3 / compatible',
  'repo.type.s3.desc': 'Configure a Restic repository on Amazon S3 or compatible object storage (MinIO, Wasabi, ...).',
  'repo.type.local': 'Local storage',
  'repo.type.local.desc': 'Store backups on a local path accessible to the agent (e.g., NFS mount).',
  'repo.type.b2': 'Backblaze B2',
  'repo.type.b2.desc': 'Configure a repository on Backblaze B2.',
  'repo.type.azure': 'Azure Blob Storage',
  'repo.type.azure.desc': 'Configure a repository on Azure Blob Storage.',
  'repo.type.sftp': 'SFTP (SSH)',
  'repo.type.sftp.desc': 'Usa un server SFTP via SSH per archiviare i backup Restic.',
  'repo.type.rest': 'REST Server',
  'repo.type.rest.desc': 'Connect to a restic REST server or compatible HTTP endpoint.',
  'repo.type.swift': 'OpenStack Swift',
  'repo.type.swift.desc': 'Use an OpenStack Swift account as Restic repository.',
  'repo.type.gs': 'Google Cloud Storage',
  'repo.type.gs.desc': 'Configure a Restic repository on Google Cloud Storage.',
  'repo.type.rclone': 'Rclone remote',
  'repo.type.rclone.desc': 'Point to any rclone-supported backend via a configured remote.',
  'repo.fields.bucket': 'Bucket',
  'repo.fields.region': 'Region',
  'repo.fields.endpoint': 'Endpoint',
  'repo.fields.access_key': 'Access key',
  'repo.fields.secret_key': 'Secret key',
  'repo.fields.password': 'Password',
  'repo.fields.prefix': 'Prefix',
  'repo.fields.storage_class': 'Storage class',
  'repo.fields.kms_key_id': 'KMS key ID',
  'repo.fields.path': 'Path',
  'repo.fields.snapshot_retention': 'Snapshot retention',
  'repo.fields.key_id': 'Key ID',
  'repo.fields.application_key': 'Application key',
  'repo.fields.account_name': 'Account name',
  'repo.fields.account_key': 'Account key',
  'repo.fields.container': 'Container',
  'repo.fields.sas_token': 'SAS token',
  'repo.fields.auth_url': 'Auth URL',
  'repo.fields.username': 'Username',
  'repo.fields.auth_password': 'Swift account password',
  'repo.fields.project': 'Project/Tenant',
  'repo.fields.tenant_id': 'Tenant ID',
  'repo.fields.domain': 'Domain',
  'repo.fields.credentials_json': 'Credentials JSON',
  'repo.fields.project_id': 'Project ID',
  'repo.fields.remote': 'Rclone remote',
  'repo.fields.config_text': 'Rclone config',
  'repo.fields.host': 'Host',
  'repo.fields.port': 'Port',
  'repo.fields.user': 'User',
  'repo.fields.remote_path': 'Remote path',
  'repo.fields.private_key': 'SSH private key',
  'repo.fields.known_hosts': 'Known hosts',
  'repo.fields.ssh_options': 'Additional SSH options',
  'repo.fields.url': 'Server URL',
  'repo.fields.http_password': 'HTTP password',
  'repo.fields.auth_token': 'Auth token',
  'repo.fields.ca_cert': 'CA certificate',
  'repo.placeholder.bucket': 'e.g., backup-bucket',
  'repo.placeholder.region': 'e.g., eu-central-1',
  'repo.placeholder.endpoint': 'e.g., https://s3.amazonaws.com',
  'repo.placeholder.access_key': 'access key',
  'repo.placeholder.secret_key': 'secret key',
  'repo.placeholder.password': 'password restic',
  'repo.placeholder.prefix': 'optional prefix',
  'repo.placeholder.storage_class': 'e.g., STANDARD',
  'repo.placeholder.kms_key_id': 'optional KMS key ARN',
  'repo.placeholder.path': 'e.g., /mnt/backups',
  'repo.placeholder.snapshot_retention': 'e.g., 30d',
  'repo.placeholder.key_id': 'B2 key ID',
  'repo.placeholder.application_key': 'B2 application key',
  'repo.placeholder.b2_endpoint': 'Custom endpoint (optional)',
  'repo.placeholder.account_name': 'e.g., backupstorage',
  'repo.placeholder.account_key': 'Account key',
  'repo.placeholder.container': 'Container name',
  'repo.placeholder.azure_endpoint': 'Custom endpoint (optional)',
  'repo.placeholder.sas_token': 'SAS token (optional)',
  'repo.placeholder.auth_url': 'https://identity.example.com/v3',
  'repo.placeholder.auth_password': 'Swift/OpenStack password',
  'repo.placeholder.project': 'e.g., backup-project',
  'repo.placeholder.tenant_id': 'Optional',
  'repo.placeholder.domain': 'Default',
  'repo.placeholder.credentials_json': '{ ... }',
  'repo.placeholder.project_id': 'e.g., my-gcp-project',
  'repo.placeholder.remote': 'gdrive',
  'repo.placeholder.config_text': '[remote]\\nclient_id=...\\nclient_secret=...',
  'repo.placeholder.host': 'backup.example.com',
  'repo.placeholder.port': '22',
  'repo.placeholder.user': 'backup',
  'repo.placeholder.remote_path': '/srv/restic',
  'repo.placeholder.private_key': '-----BEGIN OPENSSH PRIVATE KEY-----',
  'repo.placeholder.known_hosts': 'ssh-ed25519 AAAA... host',
  'repo.placeholder.ssh_options': '-o StrictHostKeyChecking=yes',
  'repo.placeholder.url': 'https://rest.example.com/backup',
  'repo.placeholder.username': 'restic',
  'repo.placeholder.http_password': 'HTTP password',
  'repo.placeholder.auth_token': 'bearer token',
  'repo.placeholder.ca_cert': '-----BEGIN CERTIFICATE-----',
  'repo.helper.private_key': 'Optional: paste the SSH key dedicated to this backup user.',
  'repo.helper.known_hosts': 'Optional: list of known hosts entries to trust.',
  'repo.helper.ssh_options': 'Extra ssh options, one per line (e.g., -o StrictHostKeyChecking=yes).',
  'repo.helper.ca_cert': 'Additional CA certificate (PEM) if the REST server uses custom TLS.',
  'repo.helper.auth_token': 'When set, sent as Bearer token for REST requests.',
  'repo.helper.credentials_json': 'Service account JSON (Google Cloud).',
  'repo.helper.config_text': 'Contents of an rclone.conf file (leave empty to use system config).',
  'repo.helper.secret_keep': 'Leave blank to keep the current value.',
  'repo.summary.secrets': 'Credentials stored securely',
  'repo.table.status': 'Status',
  'repo.table.preflight': 'Preflight',
  'repo.table.last_error': 'Last error',
  'repo.status.quarantined': 'Quarantined',
  'repo.status.healthy': 'Healthy',
  'repo.actions.unquarantine': 'Remove quarantine',
  'repo.feedback.unquarantined': 'Quarantine cleared.',
  'repo.feedback.confirm_unquarantine': 'Remove quarantine from this repository?',
  'repo.errors.unquarantine_failed': 'Failed to remove quarantine.',
  'repo.hint.quarantined': '{count} repositories are quarantined: fix credentials or connectivity, then remove quarantine manually.',
  'repo.errors.unsupported': 'Unsupported repository type.',
  'repo.errors.name_required': 'Repository name is required.',
  'repo.errors.missing_fields': 'Please fill required fields: {fields}',
  'repo.errors.load_failed': 'Failed to load repositories.',
  'repo.errors.create_failed': 'Failed to create repository.',
  'repo.feedback.created': 'Repository created.',
  'repo.feedback.updated': 'Repository updated.',
  'repo.feedback.edit_mode': 'Editing repository "{name}". Leave sensitive fields blank to keep existing credentials.',
  'repo.feedback.no_permission': 'You do not have permission to create repositories.',
  'repo.table.config': 'Configuration',
  'repo.feedback.confirm_delete': 'Delete this repository?',
  'repo.errors.update_failed': 'Failed to update repository.',
  'repo.errors.sftp_host': 'Invalid SFTP host (allowed characters: letters, digits, dot, dash, underscore).',
  'repo.errors.sftp_port': 'Invalid SFTP port (must be 1-65535).',
  'repo.errors.sftp_path': 'SFTP path must start with "/".',
  'repo.errors.rest_url': 'Invalid REST URL (use http/https).',
  'repo.errors.swift_auth_url': 'Invalid Swift auth_url (use http/https).',
  'repo.errors.gs_credentials': 'Invalid Google Cloud credentials JSON.',
  'repo.errors.rclone_remote': 'Specify the rclone remote name.',
  'restore.title': 'Restore Guide',
  'restore.subtitle': 'Select target and repository: the job performs the restore automatically (files + DB import + hooks). Manual commands remain available as fallback.',
  'restore.fields.repository': 'Repository',
  'restore.fields.note': 'Job note',
  'restore.actions.enqueue_restore': 'Enqueue restore job',
  'restore.errors.missing_selection': 'Select endpoint, repository and target first.',
  'restore.errors.enqueue_failed': 'Unable to enqueue restore job.',
  'restore.feedback.enqueue_success': 'Restore job enqueued.',
  'restore.feedback.no_targets': 'No WordPress/MySQL targets available for this endpoint.',
  'restore.latest_backup.title': 'Latest backup detected',
  'restore.latest_backup.when': 'Executed',
  'restore.latest_backup.state': 'State',
  'restore.latest_backup.site_path': 'Site path',
  'restore.latest_backup.none': 'No backup found for this target.',
  'restore.instructions.title': 'Operational instructions',
  'restore.instructions.select_target': 'Select a target to view the restore steps.',
  'restore.automation.title': 'Automated restore',
  'restore.automation.description': 'The job restores files from the repository, syncs target paths, imports the database dump and runs the configured hooks.',
  'restore.plan.snapshot': 'Snapshot',
  'restore.plan.backup_job': 'Reference backup job',
  'restore.plan.backup_time': 'Backup completed on',
  'restore.plan.paths': 'Restored paths',
  'restore.plan.extra_paths': 'Extra paths',
  'restore.plan.hooks_pre': 'Pre-restore hooks',
  'restore.plan.hooks_post': 'Post-restore hooks',
  'restore.plan.none': 'No restore plan available.',
  'restore.manual.title': 'Manual restore / fallback',
  'restore.manual.description': 'Use these commands only if you need to validate or execute the restore manually.',
  'restore.wordpress.step_intro': 'Restore WordPress files and database:',
  'restore.wordpress.step_env': '1. Export the repository environment (Restic password, storage credentials).',
  'restore.wordpress.step_sync_files': '3. Sync the restored files with the production path ({path}) after validation.',
  'restore.wordpress.step_db': '4. Import the SQL dump (e.g. `mysql -u {db_name} -p {db_name} < dump.sql`).',
  'restore.mysql.step_intro': 'Restore the MySQL dump and import it back into the database:',
  'restore.mysql.step_env': '1. Export the repository environment (Restic password, storage credentials).',
  'restore.mysql.step_find_dump': '2. Run `restic restore ... --include "*.sql"` and locate the restored `.sql` file.',
  'restore.mysql.step_import': '3. Import the dump (e.g. `mysql -u root -p {db_name} < path/dump.sql`).',
  'target.type.directory': 'Directory',
  'target.type.directory.desc': 'Back up one or more local directories with restic.',
  'target.type.nextcloud': 'Nextcloud',
  'target.type.nextcloud.desc': 'Perform a consistent Nextcloud backup (maintenance mode, DB dump, restic).',
  'target.type.postgres': 'PostgreSQL Database',
  'target.type.mongodb': 'MongoDB Database',
  'target.placeholder.dump_options': 'Additional dump options (one per line)',
  'target.placeholder.mongo_uri': 'e.g., mongodb://user:pass@host:27017/?authSource=admin',
  'target.placeholder.mongo_db': 'Database name (optional)',
  'target.type.mysql': 'MySQL/MariaDB Database',
  'target.type.mysql.desc': 'Runs mysqldump and stores the output with Restic.',
  'target.type.mssql': 'Microsoft SQL Server Database',
  'target.type.mssql.desc': 'Runs a consistent SQL Server backup and archives it with Restic.',
  'target.type.postgres.desc': 'Runs pg_dump and stores the output with Restic.',
  'target.type.mongodb.desc': 'Runs mongodump (archive format) and stores the result with Restic.',
  'target.type.managed_db': 'Managed database (RDS / Cloud SQL)',
  'target.type.managed_db.desc': 'Resolve RDS or Cloud SQL endpoints via API and run consistent dumps from the agent.',
  'target.type.s3': 'S3 / Object storage bucket',
  'target.type.s3.desc': 'Download objects from the bucket (with optional prefix) and archive them with Restic.',
  'target.type.git': 'Git Repository',
  'target.type.git.desc': 'Clone a Git repository (mirror or shallow) and archive it with Restic.',
  'target.type.wordpress': 'WordPress',
  'target.type.wordpress.desc': 'Enable maintenance (wp-cli), run mysqldump and back up site files.',
  'target.type.website': 'Website',
  'target.type.website.desc': 'Back up web application paths with maintenance toggles and multiple database dumps.',
  'target.type.imap': 'IMAP mailbox',
  'target.type.imap.desc': 'Download messages over IMAP/IMAPS and store them with Restic.',
  'target.type.google_workspace': 'Google Workspace',
  'target.type.google_workspace.desc': 'Back up Drive, Gmail and Calendar using a delegated service account.',
  'target.type.m365_exchange': 'Microsoft 365 Exchange',
  'target.type.m365_exchange.desc': 'Protect Exchange Online mailboxes and calendars via a delegated Microsoft Graph application.',
  'target.type.m365_onedrive': 'Microsoft 365 OneDrive',
  'target.type.m365_onedrive.desc': 'Back up OneDrive libraries via Microsoft Graph with file and size filters.',
  'target.type.m365_sharepoint': 'Microsoft 365 SharePoint',
  'target.type.m365_sharepoint.desc': 'Back up SharePoint Online sites with configurable versions, libraries, and lists.',
  'target.type.m365_teams': 'Microsoft 365 Teams',
  'target.type.m365_teams.desc': 'Capture Teams messages, channels, attachments, and meetings.',
  'target.form.show_advanced': 'Show advanced options',
  'target.form.hide_advanced': 'Hide advanced options',
  'target.form.advanced_populated': 'Advanced options already contain values',
  'target.fields.tenant_id': 'Tenant ID (Directory)',
  'target.placeholder.tenant_id': 'e.g. 00000000-0000-0000-0000-000000000000',
  'target.fields.client_id': 'Client ID (App)',
  'target.placeholder.client_id': 'e.g. 11111111-2222-3333-4444-555555555555',
  'target.fields.client_secret': 'Client secret',
  'target.placeholder.client_secret': '********',
  'target.fields.sharepoint_sites': 'SharePoint sites',
  'target.placeholder.sharepoint_sites': 'https://contoso.sharepoint.com/sites/marketing',
  'target.helper.sharepoint_sites': 'One per line or comma separated; accepts full URLs or site IDs.',
  'target.fields.sharepoint_site_list': 'Site list JSON',
  'target.helper.sharepoint_site_list': 'JSON with site_id plus optional libraries/lists for advanced targeting.',
  'target.fields.sharepoint_include_versions': 'Include file versions',
  'target.fields.sharepoint_max_versions': 'Max versions per file',
  'target.fields.sharepoint_exclude_paths': 'Paths to exclude',
  'target.placeholder.sharepoint_exclude_paths': '/Shared Documents/tmp',
  'target.fields.sharepoint_include_lists': 'Lists to include',
  'target.placeholder.sharepoint_include_lists': 'Announcements, Issues',
  'target.fields.sharepoint_library_query': 'Library filter',
  'target.placeholder.sharepoint_library_query': 'e.g. startswith(displayName, "Doc")',
  'target.fields.teams': 'Teams to include',
  'target.placeholder.teams': 'TeamA, TeamB',
  'target.fields.team_list': 'Team list JSON',
  'target.helper.team_list': 'JSON with team_id plus optional channels/members.',
  'target.fields.include_private_channels': 'Include private channels',
  'target.fields.include_chats': 'Include 1:1/group chats',
  'target.fields.include_meetings': 'Include meetings',
  'target.fields.chat_user_list': 'Chat users (one per line)',
  'target.placeholder.chat_user_list': 'alice@example.com, bob@example.com',
  'target.fields.max_messages': 'Max messages',
  'target.placeholder.max_messages': 'e.g. 10000',
  'target.fields.max_days': 'Days to export',
  'target.placeholder.max_days': 'e.g. 30',
  'target.fields.exchange_mode': 'Mode',
  'target.fields.exchange_modules': 'Exchange modules',
  'target.placeholder.exchange_modules': 'mail, calendar',
  'target.helper.exchange_modules': 'Leave empty for mail + calendar. Use commas to restrict modules.',
  'target.m365_sharepoint.errors.sites_required': 'Provide at least one site or a site list JSON.',
  'target.m365_sharepoint.errors.max_versions': 'Maximum versions must be a positive integer.',
  'target.m365_sharepoint.errors.site_list_invalid': 'Site list must contain valid JSON.',
  'target.m365_teams.errors.selection_required': 'Specify at least one team or enable chat backup.',
  'target.m365_teams.errors.team_list_invalid': 'Team list must contain valid JSON.',
  'target.m365_teams.errors.positive_integer': '{field} must be a positive integer.',
  'target.fields.exchange_scopes': 'Microsoft Graph scopes',
  'target.placeholder.exchange_scopes': 'https://graph.microsoft.com/.default, offline_access',
  'target.helper.exchange_scopes': 'Leave empty to rely on https://graph.microsoft.com/.default. Add more scopes separated by commas or lines.',
  'target.fields.authority_host': 'Authority host',
  'target.placeholder.authority_host': 'https://login.microsoftonline.com',
  'target.helper.authority_host': 'Needed only for sovereign clouds (e.g. https://login.microsoftonline.us).',
  'target.fields.mail_query': 'Mail filter',
  'target.placeholder.mail_query': 'e.g. received>=2024-01-01',
  'target.helper.mail_query': 'Optional: OData filter for messages (Graph).',
  'target.fields.calendar_query': 'Calendar filter',
  'target.placeholder.calendar_query': 'e.g. start/dateTime ge 2024-01-01T00:00:00Z',
  'target.helper.calendar_query': 'Optional: OData filter for events (Graph).',
  'target.fields.max_parallel_exports': 'Max parallel exports',
  'target.placeholder.max_parallel_exports': 'e.g. 4',
  'target.fields.workspace_mode': 'Mode',
  'target.options.workspace_mode.single': 'Single user',
  'target.options.workspace_mode.list': 'User list',
  'target.options.workspace_mode.group': 'Group',
  'target.fields.primary_user': 'Primary user',
  'target.placeholder.primary_user': 'user@example.com',
  'target.fields.user_list': 'User list',
  'target.placeholder.user_list': 'user1@example.com\nuser2@example.com',
  'target.helper.user_list': 'One per line; commas or semicolons are also accepted.',
  'target.fields.group_email': 'Group email',
  'target.placeholder.group_email': 'group@example.com',
  'target.fields.admin_user': 'Admin delegate account',
  'target.placeholder.admin_user': 'admin@example.com',
  'target.fields.workspace_modules': 'Modules',
  'target.placeholder.workspace_modules': 'drive, gmail, calendar',
  'target.helper.workspace_modules': 'Leave empty to include every supported module or separate with commas.',
  'target.fields.service_account_json': 'Service account JSON',
  'target.placeholder.service_account_json': '{ "type": "service_account", ... }',
  'target.helper.service_account_json': 'Paste the service account JSON with domain-wide delegation enabled.',
  'target.fields.drive_include_shared': 'Include shared files',
  'target.helper.drive_include_shared': 'Disable to exclude items shared with the primary user.',
  'target.fields.drive_query': 'Drive query',
  'target.placeholder.drive_query': 'e.g. modifiedTime > "2024-01-01T00:00:00Z"',
  'target.helper.drive_query': 'Optional: use the Drive search syntax to filter files.',
  'target.fields.drive_max_files': 'Max Drive files',
  'target.placeholder.drive_max_files': 'e.g. 1000',
  'target.fields.onedrive_max_files': 'OneDrive file limit',
  'target.placeholder.onedrive_max_files': 'e.g. 5000',
  'target.helper.onedrive_max_files': 'Stops the export after this many files.',
  'target.fields.onedrive_max_bytes': 'OneDrive byte limit',
  'target.placeholder.onedrive_max_bytes': 'e.g. 2147483648',
  'target.helper.onedrive_max_bytes': 'Aborts the export once this byte threshold is reached.',
  'target.fields.onedrive_exclude_extensions': 'Excluded extensions',
  'target.placeholder.onedrive_exclude_extensions': 'e.g. tmp,log,bak',
  'target.helper.onedrive_exclude_extensions': 'Separate with commas or new lines; omit the leading dot.',
  'target.fields.gmail_query': 'Gmail query',
  'target.placeholder.gmail_query': 'e.g. newer_than:30d',
  'target.helper.gmail_query': 'Optional: Gmail search query (same syntax as the web UI).',
  'target.fields.gmail_label': 'Gmail label',
  'target.placeholder.gmail_label': 'Backup',
  'target.fields.gmail_max_messages': 'Max Gmail messages',
  'target.placeholder.gmail_max_messages': 'e.g. 5000',
  'target.fields.calendar_time_min': 'Calendar from',
  'target.fields.calendar_time_max': 'Calendar to',
  'target.placeholder.calendar_time_min': '2024-01-01T00:00:00Z',
  'target.placeholder.calendar_time_max': '2024-12-31T23:59:59Z',
  'target.fields.calendar_max_events': 'Max calendar events',
  'target.placeholder.calendar_max_events': 'e.g. 5000',
  'target.helper.calendar_time': 'ISO 8601 (e.g. 2024-01-01T00:00:00Z); leave empty to include everything.',
  'target.fields.site_path': 'Site path',
  'target.placeholder.site_path': '/var/www/html',
  'target.fields.wp_cli_cmd': 'wp-cli command',
  'target.placeholder.wp_cli_cmd': 'e.g., sudo -u www-data wp --path=/var/www/html',
  'target.helper.wp_cli_cmd': 'Optional, used to toggle maintenance-mode before/after backup.',
  'target.fields.dump_options': 'Dump options',
  'target.helper.dump_options': 'Example: --single-transaction or --no-owner.',
  'target.fields.mongo_uri': 'MongoDB URI',
  'target.fields.mongo_db': 'MongoDB database',
  'target.fields.dump_args': 'mongodump parameters',
  'target.placeholder.dump_args': 'Additional mongodump options',
  'target.helper.dump_args': 'Example: --gzip or --collection=my_collection.',
  'target.fields.paths': 'Paths',
  'target.placeholder.paths': 'One path per line or comma separated',
  'target.fields.exclude': 'Exclude',
  'target.placeholder.exclude': 'Patterns to exclude (one per line)',
  'target.fields.tags': 'Restic tags',
  'target.placeholder.tags': 'tag1, tag2',
  'target.fields.note': 'Note',
  'target.placeholder.note': 'Optional note',
  'target.placeholder.imap_host': 'imap.example.com',
  'target.placeholder.imap_port': 'e.g., 993',
  'target.placeholder.imap_username': 'user@example.com',
  'target.placeholder.imap_password': 'password or app password',
  'target.placeholder.imap_mailboxes': 'INBOX\nSent',
  'target.helper.imap_mailboxes': 'One mailbox per line; leave empty for INBOX',
  'target.placeholder.imap_max_messages': 'e.g., 100 (empty = all)',
  'target.fields.nc_path': 'Nextcloud path',
  'target.placeholder.nc_path': '/var/www/nextcloud',
  'target.fields.data_path': 'Data directory',
  'target.placeholder.data_path': '/var/nc-data',
  'target.fields.extra_paths': 'Extra paths',
  'target.placeholder.extra_paths': 'Additional paths (one per line)',
  'target.helper.extra_paths': 'Optional: additional paths to include, one per line.',
  'target.fields.occ_cmd': 'occ command',
  'target.placeholder.occ_cmd': 'e.g., sudo -u www-data php /var/www/nextcloud/occ',
  'target.helper.occ_cmd': 'Leave empty to use "php <nc_path>/occ".',
  'target.fields.db_type': 'Database',
  'target.options.db_type.mysql': 'MySQL / MariaDB',
  'target.options.db_type.postgres': 'PostgreSQL',
  'target.options.boolean.true': 'Si',
  'target.options.boolean.false': 'No',
  'target.fields.db_host': 'DB host',
  'target.placeholder.db_host': 'localhost',
  'target.fields.db_port': 'DB port',
  'target.placeholder.db_port': 'e.g., 3306',
  'target.placeholder.db_port_mysql': 'e.g., 3306',
  'target.placeholder.db_port_mssql': 'e.g., 1433',
  'target.placeholder.db_port_postgres': 'e.g., 5432',
  'target.fields.db_socket': 'DB socket',
  'target.placeholder.db_socket': '/var/run/mysqld/mysqld.sock',
  'target.placeholder.db_socket_mysql': '/var/run/mysqld/mysqld.sock',
  'target.placeholder.db_socket_postgres': '/var/run/postgresql/.s.PGSQL.5432',
  'target.fields.db_name': 'DB name',
  'target.placeholder.db_name': 'nextcloud',
  'target.fields.db_user': 'DB user',
  'target.fields.db_username': 'DB user',
  'target.placeholder.db_user': 'nc_user',
  'target.placeholder.db_username': 'admin',
  'target.fields.db_password': 'DB password',
  'target.placeholder.db_password': 'password',
  'target.fields.db_instance': 'SQL Server instance',
  'target.placeholder.db_instance': 'e.g., SQLEXPRESS',
  'target.helper.db_instance': 'Optional: specify the instance name when the default instance is not used.',
  'target.fields.trust_server_certificate': 'Trust server certificate',
  'target.helper.trust_server_certificate': 'Choose "Yes" only when you must accept self-signed or untrusted TLS certificates.',
  'target.fields.managed_provider': 'Managed DB provider',
  'target.fields.db_engine': 'Database engine',
  'target.fields.instance_id': 'Instance ID',
  'target.placeholder.instance_id': 'e.g. rds-instance-1',
  'target.fields.region': 'Region',
  'target.placeholder.region': 'e.g. eu-west-1',
  'target.fields.project_id': 'Project ID',
  'target.placeholder.project_id': 'e.g. my-gcp-project',
  'target.fields.aws_access_key_id': 'AWS access key ID',
  'target.placeholder.aws_access_key_id': 'AKIA...',
  'target.fields.aws_secret_access_key': 'AWS secret access key',
  'target.placeholder.aws_secret_access_key': '********',
  'target.fields.aws_session_token': 'AWS session token',
  'target.placeholder.aws_session_token': 'Temporary token (optional)',
  'target.fields.bucket': 'Bucket',
  'target.placeholder.bucket': 'e.g. backup-production',
  'target.fields.prefix': 'Prefix',
  'target.placeholder.prefix': 'e.g. exports/',
  'target.helper.s3_prefix': 'Optional filter; only download objects starting with this prefix (no leading slash).',
  'target.fields.endpoint': 'S3 endpoint',
  'target.placeholder.endpoint': 'e.g. https://s3.eu-west-1.amazonaws.com',
  'target.helper.s3_endpoint': 'Leave empty for AWS. Provide URL for S3-compatible services (MinIO, Ceph, etc.).',
  'target.fields.include_glacier': 'Include Glacier/Archive',
  'target.helper.include_glacier': 'Attempt to download Glacier / Deep Archive objects (requires retrieval and may fail).',
  'target.fields.force_path_style': 'Force path-style',
  'target.helper.force_path_style': 'Use path-style requests (needed for MinIO or some compatible endpoints).',
  'target.fields.use_accelerate_endpoint': 'Use accelerate endpoint',
  'target.helper.use_accelerate_endpoint': 'Enable AWS Transfer Acceleration for buckets where it is configured.',
  'target.fields.object_limit': 'Object limit',
  'target.placeholder.object_limit': 'e.g. 1000',
  'target.helper.object_limit': 'Stop downloading after this many objects (handy for smoke tests).',
  'target.fields.max_total_bytes': 'Total bytes limit',
  'target.placeholder.max_total_bytes': 'e.g. 1073741824',
  'target.helper.max_total_bytes': 'Abort once the cumulative downloaded bytes reach the specified threshold.',
  'target.fields.gcp_service_account': 'Service account JSON',
  'target.placeholder.gcp_service_account': '{ ... }',
  'target.helper.gcp_service_account': 'Paste the full service account JSON with Cloud SQL Admin permissions.',
  'target.fields.use_private_ip': 'Use private IP',
  'target.options.managed_provider.aws_rds': 'AWS RDS',
  'target.options.managed_provider.gcp_cloudsql': 'GCP Cloud SQL',
  'target.managed_db.errors.provider_required': 'Select a managed DB provider.',
  'target.managed_db.errors.engine_required': 'Select the database engine.',
  'target.managed_db.errors.aws_missing': 'Missing AWS fields: {fields}',
  'target.managed_db.errors.gcp_missing': 'Missing Cloud SQL fields: {fields}',
  'target.managed_db.errors.gcp_service_account_invalid': 'Service account JSON is not valid.',
  'target.google_workspace.errors.mode_required': 'Select a valid mode (single, list, group).',
  'target.google_workspace.errors.service_account': 'Paste the service account JSON.',
  'target.google_workspace.errors.service_account_invalid': 'Service account JSON is not valid.',
  'target.google_workspace.errors.modules_invalid': 'Unsupported module: {value}. Use drive, gmail or calendar.',
  'target.google_workspace.errors.modules_required': 'Select at least one supported module.',
  'target.google_workspace.errors.email_required': '{field} is required.',
  'target.google_workspace.errors.email_invalid': '{field} must be a valid email address.',
  'target.google_workspace.errors.user_list_required': 'Provide at least one email for list mode.',
  'target.google_workspace.errors.user_list_entry': 'Invalid address in the user list: {value}.',
  'target.google_workspace.errors.positive_integer': '{field} must be a positive integer.',
  'target.google_workspace.errors.datetime': '{field} must be a valid ISO 8601 datetime.',
  'target.m365_exchange.errors.mode_required': 'Select a valid mode (single, list, group).',
  'target.m365_exchange.errors.modules_invalid': 'Unsupported module: {value}. Use mail or calendar.',
  'target.m365_exchange.errors.email_required': '{field} is required.',
  'target.m365_exchange.errors.email_invalid': '{field} must be a valid email address.',
  'target.m365_exchange.errors.user_list_required': 'Provide at least one email for list mode.',
  'target.m365_exchange.errors.user_list_entry': 'Invalid address in the user list: {value}.',
  'target.m365_exchange.errors.positive_integer': '{field} must be a positive integer.',
  'target.m365_onedrive.errors.mode_required': 'Select a valid mode (single, list, group).',
  'target.m365_onedrive.errors.email_required': '{field} is required.',
  'target.m365_onedrive.errors.email_invalid': '{field} must be a valid email address.',
  'target.m365_onedrive.errors.user_list_required': 'Provide at least one email for list mode.',
  'target.m365_onedrive.errors.user_list_entry': 'Invalid address in the user list: {value}.',
  'target.m365_onedrive.errors.positive_integer': '{field} must be a positive integer.',
  'target.s3.errors.credentials_pair': 'Either fill both access key and secret key, or leave both empty (use IAM role).',
  'target.s3.errors.object_limit': 'Object limit must be a positive integer.',
  'target.s3.errors.max_total_bytes': 'Total bytes limit must be a positive integer.',
  'target.fields.git_remote_url': 'Repository URL',
  'target.placeholder.git_remote_url': 'https://git.example.com/org/repo.git',
  'target.fields.git_auth_method': 'Auth method',
  'target.helper.git_auth_method': 'Auto detects credentials; override to force a specific method.',
  'target.options.git_auth.auto': 'Automatic',
  'target.options.git_auth.none': 'None (public)',
  'target.options.git_auth.token': 'HTTP token',
  'target.options.git_auth.basic': 'Basic (username/password)',
  'target.options.git_auth.ssh': 'SSH key',
  'target.fields.git_token_username': 'Token username',
  'target.placeholder.git_token_username': 'e.g., oauth2',
  'target.helper.git_token_username': 'Optional override for the username used together with the token.',
  'target.fields.git_token': 'Token',
  'target.placeholder.git_token': 'ghp_xxxxx',
  'target.helper.git_token': 'Paste a personal access token or deploy token with read access.',
  'target.fields.git_username': 'Username',
  'target.placeholder.git_username': 'git-user',
  'target.fields.git_password': 'Password',
  'target.placeholder.git_password': 'password',
  'target.helper.git_basic': 'Required for HTTP Basic authentication.',
  'target.fields.git_ssh_private_key': 'SSH private key',
  'target.placeholder.git_ssh_private_key': '-----BEGIN OPENSSH PRIVATE KEY-----',
  'target.helper.git_ssh_private_key': 'PEM key without passphrase; stored temporarily on the job host.',
  'target.fields.git_ssh_known_hosts': 'Known hosts',
  'target.placeholder.git_ssh_known_hosts': 'git.example.com ssh-ed25519 AAAA...',
  'target.helper.git_known_hosts': 'Optional: provide known_hosts entries to enforce SSH host verification.',
  'target.fields.git_mirror': 'Mirror clone',
  'target.helper.git_mirror': 'Mirror downloads all remote refs. Disable for a standard working tree clone.',
  'target.fields.git_depth': 'Depth (shallow)',
  'target.placeholder.git_depth': 'e.g., 100',
  'target.helper.git_depth': 'Positive value for shallow clones (only when mirror is disabled).',
  'target.fields.tmp_dir': 'Temp directory',
  'target.placeholder.tmp_dir': '/tmp',
  'target.fields.maintenance_enabled': 'Maintenance enabled',
  'target.fields.maintenance_on_cmd': 'Maintenance ON command',
  'target.fields.maintenance_off_cmd': 'Maintenance OFF command',
  'target.placeholder.maintenance_on_cmd': 'e.g., sudo -u www-data ./maintenance-on.sh',
  'target.placeholder.maintenance_off_cmd': 'e.g., sudo -u www-data ./maintenance-off.sh',
  'target.helper.maintenance_on_cmd': 'Executed before the backup when maintenance mode is enabled.',
  'target.helper.maintenance_off_cmd': 'Executed after the backup to bring the site back online.',
  'target.fields.databases': 'Additional databases',
  'target.placeholder.databases': '[{"type":"mysql","db_name":"app","db_user":"user","db_password":"***"}]',
  'target.helper.databases': 'Manage extra databases here: click "Add database" for each entry and fill the required fields.',
  'target.website.database_hint': 'Map additional databases without writing JSON; they will be serialised automatically.',
  'target.website.buttons.add_db': 'Add database',
  'target.website.buttons.remove_db': 'Remove database',
  'target.website.database_label': 'Database {index}',
  'target.website.errors.database_required': 'Provide at least one extra database entry or fill the main database fields.',
  'target.fields.exclude_paths': 'Exclude paths',
  'target.placeholder.exclude_paths': 'Patterns to exclude (one per line)',
  'target.fields.include_cache': 'Include cache/previews',
  'target.fields.imap_host': 'IMAP host',
  'target.fields.imap_port': 'IMAP port',
  'target.fields.imap_use_ssl': 'Use SSL',
  'target.fields.imap_username': 'IMAP username',
  'target.fields.imap_password': 'IMAP password',
  'target.fields.imap_mailboxes': 'Mailboxes',
  'target.fields.imap_max_messages': 'Message limit (debug)',
  'target.summary.google_workspace': 'Mode {mode} • Modules {modules} • Users {users}',
  'target.summary.m365_exchange': 'Mode {mode} • Modules {modules} • Mailboxes {mailboxes}',
  'target.summary.m365_onedrive': 'Mode {mode} • Users {users}',
  'target.summary.onedrive_files': 'Files exported: {value}',
  'target.summary.onedrive_bytes': 'Bytes exported: {value}',
  'target.summary.onedrive_shared': 'Shared items included: {value}',
  'target.summary.onedrive_query': 'Query: {value}',
  'target.summary.onedrive_excludes': 'Excludes: {value}',
  'target.summary.onedrive_max_files': 'File limit: {value}',
  'target.summary.onedrive_max_bytes': 'Byte limit: {value}',
  'target.summary.sharepoint_sites': 'Sites: {value}',
  'target.summary.sharepoint_libraries': 'Libraries: {value}',
  'target.summary.sharepoint_files': 'Files: {value}',
  'target.summary.sharepoint_bytes': 'Bytes: {value}',
  'target.summary.teams_processed': 'Teams: {value}',
  'target.summary.teams_channels': 'Channels: {value}',
  'target.summary.teams_messages': 'Messages: {value}',
  'target.summary.teams_attachments': 'Attachments: {value}',
  'target.summary.teams_meetings': 'Meetings: {value}',
  'target.summary.sample_user': 'Sample user: {value}',
  'target.summary.sample_mailbox': 'Sample mailbox: {value}',
  'target.summary.group': 'Group: {value}',
  'target.summary.admin': 'Admin: {value}',
  'target.summary.secrets': 'Target secrets stored securely',
  'target.table.config': 'Configuration',
  'target.feedback.no_permission': 'You do not have permission to create targets.',
  'target.feedback.confirm_delete': 'Delete this target?',
  'target.feedback.edit_mode': 'Editing target "{name}". Leave secret fields blank to keep the current value.',
  'target.feedback.secret_hint': 'Leave blank to keep the current value.',
  'target.feedback.no_changes': 'No changes to save.',
  'target.errors.name_required': 'Target name is required.',
  'target.errors.unsupported': 'Unsupported target type.',
  'target.errors.missing_fields': 'Please fill required fields: {fields}',
  'target.git.errors.token_required': 'Provide a valid token when using the token method.',
  'target.git.errors.basic_required': 'Provide username and password when using basic authentication.',
  'target.git.errors.ssh_required': 'Paste an SSH private key (without passphrase) for SSH authentication.',
  'target.errors.create_failed': 'Failed to create target.',
  'target.placeholder.select': 'Select',
  'agents.errors.load': 'Failed to load agents',
  'agents.errors.installer': 'Failed to generate installer',
  'agents.errors.docker': 'Failed to generate Docker command',
  'agents.feedback.docker_copy': 'Docker command copied to clipboard',
  'agents.confirm.rotate': 'Rotate key for agent #{id}?',
  'agents.feedback.new_key': 'New key',
  'agents.feedback.key_hint': '(see response)',
  'agents.confirm.delete': 'Delete agent #{id}?',
  'agents.mode.paused': 'Paused',
  'agents.mode.simulate': 'Simulation',
  'agents.mode.real': 'Real run',
  'agents.table.mode': 'Mode',
  'agents.actions.resume': 'Resume',
  'agents.actions.pause': 'Pause',
  'agents.actions.set_real': 'Switch to real',
  'agents.actions.set_simulate': 'Switch to simulate',
  'agents.actions.installer': 'Linux installer',
  'agents.actions.rotate': 'Rotate key',
  'agents.actions.delete': 'Delete',
  'agents.feedback.mode_updated': 'Agent mode updated.',
  'agents.errors.mode_update': 'Failed to update agent mode.',
  'help.jobs': 'List of jobs (backup, check, prune, restore). Filter by state/endpoint/type/date range; search payload/notes. You can trigger manual backups and export CSV.',
  'jobs.errors.endpoint_required': 'Select an endpoint.',
  'jobs.errors.repository_required': 'Select a repository.',
  'jobs.errors.target_required': 'Select a target.',
  'jobs.feedback.enqueued': 'Job enqueued.',
  'jobs.errors.enqueue_failed': 'Failed to enqueue job.',
  'jobs.errors.repo_quarantined': 'Repository is quarantined: enable force override after fixing the issue.',
  'jobs.fields.allow_quarantined': 'Force execution despite quarantine',
  'jobs.fields.backup_mode': 'Backup mode',
  'jobs.fields.mode': 'Mode',
  'jobs.fields.snapshot': 'Snapshot',
  'jobs.fields.chain': 'Chain',
  'jobs.mode.policy': 'Policy default',
  'jobs.mode.full': 'Full',
  'jobs.mode.differential': 'Differential',
  'jobs.mode.incremental': 'Incremental',
  'jobs.mode.log': 'Log',
  'jobs.hint.repo_quarantined': 'Selected repository is quarantined: double-check credentials/connectivity before forcing the backup.',
  'home.size.title': 'Backup size trend',
  'home.size.no_data': 'No data available',
  'home.size.anomalies': 'Recent anomalies',
  'home.size.view_job': 'View job',
  'home.size.anomalies_more': '+{count} more anomalies',
  'jobs.placeholder.endpoint': 'Select endpoint',
  'jobs.placeholder.repository': 'Select repository',
  'jobs.placeholder.target': 'Select target',
  'help.rbac': 'Manage roles and permissions per tenant. Select a user and a role to assign to the active tenant. Roles control allowed actions.',
  'help.health': 'Backend services status (DB, Redis, OIDC). If a service is not OK, use details for troubleshooting.',
  'policy.kpi.type.full_age': 'Last full age',
  'policy.kpi.fields.max_age_hours': 'Max hours since full',
  'policy.kpi.add_full': 'Add full-age rule',
}

const DICTS: Record<Lang, Dict> = {
  it: IT_DICT,
  en: EN_DICT,
}

const LANG_KEY = 'lang'

type Ctx = { lang: Lang, setLang: (l: Lang) => void, t: (key: string, params?: Record<string,string|number>) => string }
const I18nCtx = createContext<Ctx | null>(null)

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const initial: Lang = ((localStorage.getItem(LANG_KEY) as Lang) || (navigator.language?.startsWith('it') ? 'it' : 'en'))
  const [lang, setLangState] = useState<Lang>(initial)
  const setLang = (l: Lang) => { localStorage.setItem(LANG_KEY, l); setLangState(l) }
  const t = (key: string, params?: Record<string,string|number>) => {
    const dict = DICTS[lang] || DICTS.en
    const fallback: Record<string,string> = lang === 'it' ? {
      'common.loading': 'Caricamento...',
      'table.id': 'ID', 'table.name': 'Nome', 'table.type': 'Tipo', 'table.state': 'Stato', 'table.created': 'Creato', 'table.actions': 'Azioni', 'table.endpoint': 'Endpoint', 'table.last': 'Ultimo', 'table.agent': 'Agente', 'table.schedule': 'Pianificazione', 'table.retention': 'Retention', 'table.stateful': 'Stateful', 'table.enabled': 'Abilitato',
      'ph.name': 'nome', 'ph.schedule': 'schedule (es. daily@02:30)', 'ph.retention': 'retention (es. GFS 7/4/6)', 'ph.search': 'cerca in payload/note', 'ph.task_type': 'tipo task (opz)', 'ph.from': 'dal', 'ph.to': 'al', 'ph.note': 'nota', 'ph.subject': 'Oggetto', 'ph.description': 'Descrizione', 'ph.contact': 'Contatto (email/telefono)'
    } : {
      'common.loading': 'Loading...',
      'table.id': 'ID', 'table.name': 'Name', 'table.type': 'Type', 'table.state': 'State', 'table.created': 'Created', 'table.actions': 'Actions', 'table.endpoint': 'Endpoint', 'table.last': 'Last', 'table.agent': 'Agent', 'table.schedule': 'Schedule', 'table.retention': 'Retention', 'table.stateful': 'Stateful', 'table.enabled': 'Enabled',
      'ph.name': 'name', 'ph.schedule': 'schedule (e.g., daily@02:30)', 'ph.retention': 'retention (e.g., GFS 7/4/6)', 'ph.search': 'search in payload/note', 'ph.task_type': 'task type (opt)', 'ph.from': 'from', 'ph.to': 'to', 'ph.note': 'note', 'ph.subject': 'Subject', 'ph.description': 'Description', 'ph.contact': 'Contact (email/phone)'
    }
    let s = dict[key] || fallback[key] || key
    if (params) {
      Object.entries(params).forEach(([k,v]) => { s = s.replace(new RegExp(`\\{${k}\\}`,'g'), String(v)) })
    }
    return s
  }
  const value = useMemo(() => ({ lang, setLang, t }), [lang])
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>
}

export function useI18n() {
  const ctx = useContext(I18nCtx)
  if (!ctx) return { lang: 'en' as Lang, setLang: (_:Lang)=>{}, t: (k:string)=>k }
  return ctx
}
























